(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("angular-resource"), require("jquery"), require("moment"), require("angular-translate"), require("angular-dynamic-locale"), require("angular-sanitize"));
	else if(typeof define === 'function' && define.amd)
		define(["base", "angular-resource", "jquery", "moment", "angular-translate", "angular-dynamic-locale", "angular-sanitize"], factory);
	else if(typeof exports === 'object')
		exports["core"] = factory(require("base"), require("angular-resource"), require("jquery"), require("moment"), require("angular-translate"), require("angular-dynamic-locale"), require("angular-sanitize"));
	else
		root["core"] = factory(root["base"], root["angular-resource"], root["jquery"], root["moment"], root["angular-translate"], root["angular-dynamic-locale"], root["angular-sanitize"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_18__, __WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_24__, __WEBPACK_EXTERNAL_MODULE_33__, __WEBPACK_EXTERNAL_MODULE_34__, __WEBPACK_EXTERNAL_MODULE_35__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               * Launchpad Core module contains commonly used APIs for all Launchpad modules.
	               *
	               * @usage
	               * ###Install
	               * 1. Install core module:
	               *
	               * ```
	               * bower i core --save
	               * ```
	               *
	               * 2. Add `core` as a dependency of your angular module:
	               *
	               * ```
	               * // main.js
	               * var core = require('core');
	               * var deps = [
	               *   ...
	               *   core.name,
	               *   ...
	               * ];
	               *
	               * module.exports = base.createModule(module.name, deps);
	               * ```
	               *
	               * ###Develop
	               *
	               * ```
	               * git clone ssh://git@stash.backbase.com:7999/LPM/foundation-core.git
	               * cd core
	               *
	               * bower install && bblp start
	               * ```
	               *
	               * ###Testing
	               *
	               * ```
	               * bblp test
	               * ```
	               *
	               * ###Build
	               *
	               * ```
	               * bblp build
	               * ```
	               *
	               * @name core
	               * @ngModule
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    module.name = 'core';

	    var base = __webpack_require__(3);
	    var bus = __webpack_require__(4);
	    var cache = __webpack_require__(9);
	    var configuration = __webpack_require__(13);
	    var error = __webpack_require__(14);
	    var http = __webpack_require__(17);
	    var i18n = __webpack_require__(32);
	    var portal = __webpack_require__(10);
	    var store = __webpack_require__(43);
	    var template = __webpack_require__(44);
	    var update = __webpack_require__(45);
	    var utils = __webpack_require__(21);
	    var widget = __webpack_require__(48);

	    var migration = __webpack_require__(50);
	    var deprecated = __webpack_require__(52);

	    module.exports = base.createModule(module.name, [
	    update.name,
	    portal.name,
	    utils.name,
	    i18n.name,
	    bus.name,
	    cache.name,
	    http.name,
	    error.name,
	    store.name,
	    template.name,
	    configuration.name,
	    widget.name,

	    // To be migrated
	    migration.name,

	    // Migrated and moved to depreacted, will be removed in next breaking release
	    deprecated.name]);


	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               * A mediator object that implements
	               * the <a href="http://en.wikipedia.org/wiki/Publish%E2%80%93subscribe_pattern" target="_blank">pub/sub pattern</a>.
	               * Any object can publish an event, optionally passing some data
	               * in a channel, and all the subscribed listeners to that
	               * event in that channel will be called in order.
	               *
	               * @copyright Backbase B.V.
	               * @author Backbase R&D - Amsterdam - New York
	               *
	               * @name bus
	               * @memberof core
	               * @ngModule
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	  'use strict';

	  module.name = 'bus';
	  var base = __webpack_require__(3);
	  var deps = [];

	  module.exports = base.createModule(module.name, deps).
	  factory(__webpack_require__(5)).
	  provider(__webpack_require__(6));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	              *  ----------------------------------------------------------------
	              *  Copyright © Backbase B.V.
	              *  ----------------------------------------------------------------
	              *  Author : Backbase R&D - Amsterdam - New York
	              *  Filename : factories.js
	              *  Description: Bus factories
	              *  ----------------------------------------------------------------
	              */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    /**
	                   * lpCoreChannelBus provides with chanelled pubsub instance.
	                   *
	                   * @example
	                   * ```
	                   * var channel = lpCoreChannelBus.getInstance('channel-name');
	                    * // then use as regular lpCoreBus
	                   * channel.subscribe('someEvent', handler);
	                   * ```
	                   * event name will be transformed to: "channel-name:someEvent"
	                   *
	                   * @memberof core.bus
	                   * @ngFactory
	                   * @ngInject
	                   */

	    exports.lpCoreChannelBus = function (lpCoreBus) {
	        var instances = [];

	        function ChannelBus(channelName) {
	            this.channel = channelName ? channelName + ':' : '';
	        }

	        ChannelBus.prototype.publish = function (event /*, param1, ... , paramN*/) {
	            arguments[0] = this.channel + event;
	            lpCoreBus.publish.apply(lpCoreBus, arguments);
	        };

	        ChannelBus.prototype.subscribe = function (event, handler) {
	            lpCoreBus.subscribe(this.channel + event, handler);
	        };

	        ChannelBus.prototype.unsubscribe = function (event, handler) {
	            lpCoreBus.unsubscribe(this.channel + event, handler);
	        };

	        ChannelBus.prototype.flush = function (event) {
	            lpCoreBus.flush(this.channel + event);
	        };

	        return {
	            /**
	                  * get lpCoreBus instance by channel name
	                  * @param  {string} channelName
	                  * @return {object} channeled lpCoreBus instance
	                  */
	            getInstance: function getInstance(channelName) {
	                return instances[channelName] = instances[channelName] || new ChannelBus(channelName);
	            } };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - New York
	               *  Filename : provider.js
	               *  Description: Bus Provider
	               *  ----------------------------------------------------------------
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var EventEmitter = __webpack_require__(7);
	    var EventPubSub = __webpack_require__(8);

	    /**
	                                                 * NOTE: If `windows.gadgets.pubsub` is available, this service is just a wrapper around EventPubsub.
	                                                 *
	                                                 * All event names should include the source of the event and the type of event separated by a colon character.
	                                                 *
	                                                 * @memberof core.bus
	                                                 * @ngProvider
	                                                 */
	    exports.lpCoreBus = function () {

	        this.registerChannel = function (eventChannel) {
	            this.channel = eventChannel;
	        };

	        // @ngInject
	        this.$get = function () {
	            var pubsub = window.gadgets && window.gadgets.pubsub;
	            if (pubsub) {
	                var eventPubSub = EventPubSub.create();
	                eventPubSub.registerChannel(this.channel);
	                return eventPubSub;
	            }

	            /**
	               * @alias core.bus.lpCoreBus
	               */
	            var API = {};
	            var emitter = EventEmitter.create();

	            /**
	                                                  * Adds the specified event listener for the specified event.
	                                                  * Allows subscription to the events published by other Launchpad modules / widgets.
	                                                  *
	                                                  * @example
	                                                  * ```
	                                                  * bus.subscribe('someEvent', function (data) {
	                                                  *   console.log('Event has published with:', data);
	                                                  * });
	                                                  * ```
	                                                  *
	                                                  * @param name {String} Event name
	                                                  * @param callback {Function} Listener
	                                                  * @returns {Undefined}
	                                                  */
	            API.subscribe = function (name, callback) {
	                emitter.on(name, callback);
	            };

	            /**
	                * This method is implemented by eventpubsub.
	                * Here it's just a wrapper for subscribe method when EventEmitter is used.
	                */
	            API.subscribeGlobal = function (name, callback) {
	                API.subscribe(name, callback);
	            };

	            /**
	                * Publishes the specified event.
	                * Allows publishing of events that other modules / widgets can subscribe to.
	                *
	                * @example
	                * ```
	                * var handler = function (arg1, arg2) {
	                *   console.log('Event has published', arg1, arg2);
	                * };
	                *
	                * bus.subscribe('someEvent', handler);
	                * bus.publish('someEvent', 'Hello', {foo: 'bar'}); // Event has published, Hello, {foo: "bar"}
	                * ```
	                *
	                * @param name {String} Event name
	                * @returns {Undefined}
	                */
	            API.publish = function (name /*, argument1, ..., argumentN*/) {
	                emitter.emit.apply(emitter, arguments);
	            };

	            /**
	                * This method is implemented by eventpubsub.
	                * Here it's just a wrapper for publish method when EventEmitter is used.
	                */
	            API.publishGlobal = function (name /*, argument1, ..., argumentN*/) {
	                API.publish(name /*, argument1, ..., argumentN*/);
	            };

	            /**
	                * Unsubscribes callback function from the event published by other Launchpad modules / widgets.
	                *
	                * @example
	                * ```
	                * var handler = function () {
	                *   console.log('Event has published');
	                * };
	                *
	                * bus.subscribe('someEvent', handler);
	                * bus.publish('someEvent'); // Event has published
	                *
	                * bus.unsubscribe('someEvent', handler);
	                * bus.publish('someEvent'); // Nothing happened here
	                * ```
	                *
	                * @param name {String} Event name
	                * @param callback {Function} Listener
	                * @returns {Undefined}
	                */
	            API.unsubscribe = function (name, callback) {
	                emitter.off(name, callback);
	            };

	            /**
	                * This method is implemented by eventpubsub.
	                * Here it's just a wrapper for unsubscribe method when EventEmitter is used.
	                */
	            API.unsubscribeGlobal = function (name, callback) {
	                API.unsubscribe(name, callback);
	            };
	            /**
	                * Provides the internal eventemitter to use separetely from the bus itself.
	                * It is useful sometimes to emit and listen events between cooperating objects.
	                *
	                * Available only if `window.gadgets.pubsub` is not available.
	                *
	                * @example
	                * For that you can create a new eventemitter:
	                * ```
	                * var emitter = lpCoreBus.EventEmitter.create();
	                *
	                * emitter.on('warning', function(message) {
	                *   console.log(message);
	                * });
	                *
	                * emitter.emit('warning', 'Lorem ipsum');
	                * ```
	                *
	                * @example
	                * or you can mix the eventemitter methods right into the object
	                * and use them as it were part of the original object:
	                * ```
	                * var alerts = {
	                *   show: function (message) {
	                *     ...
	                *     this.emit('show', message);
	                *   }
	                * };
	                *
	                * lpCoreBus.EventEmitter.mixin(alerts);
	                * ```
	                */
	            API.EventEmitter = EventEmitter;

	            return API;
	        };


	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - New York
	               *  Filename : eventemitter.js
	               *  Description: A simple event emitter factory to use in any module
	               *  ----------------------------------------------------------------
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    function indexOf(listeners, listener) {
	        var idx = listeners.length;
	        var value;

	        while (idx--) {
	            value = listeners[idx][0];
	            if (value === listener || value.listener && value.listener === listener) {
	                return idx;
	            }
	        }

	        return -1;
	    }

	    function defined(thing) {
	        return typeof thing !== 'undefined';
	    }

	    /**
	       * Executes each of the listeners in order with the supplied arguments.
	       * @param   {String} event Name of the event
	       * @returns {Object}       Chainable methods
	       */
	    function emit(event) {
	        var listeners = this.listeners(event).slice();
	        var singleArg = arguments.length === 1;
	        var slice = Array.prototype.slice;
	        var idx = 0;
	        var len = listeners.length;

	        for (; idx < len; idx++) {
	            if (singleArg) {
	                if (defined(listeners[idx][1])) {
	                    listeners[idx][0].call(listeners[idx][1]);
	                } else
	                {
	                    listeners[idx][0]();
	                }
	            } else {
	                listeners[idx][0].apply(listeners[idx][1], slice.call(arguments, 1));
	            }
	        }

	        return this;
	    }

	    function EventEmitter() {}

	    EventEmitter.prototype = {
	        /**
	                                * Adds an `event` `listener` to the end of the listeners array for
	                                * the specified `event`.
	                                * @param   {String}   event    Name of the event
	                                * @param   {Function} listener Handler to be added
	                                * @param   {Object}   thisp    Object to be bound to the listener
	                                * @returns {Object}            Chainable methods
	                                */
	        on: function on(event, listener, thisp) {
	            var listeners = this.listeners(event);

	            if (indexOf(listeners, listener) < 0) {
	                listeners.push([listener, thisp]);
	            }

	            return this;
	        },

	        /**
	            * Removes a `listener` from the listener array for that `event`. If the
	            * `listener` is not provided removes all the listeners for that `event`.
	            * @param   {String}   event    Name of the event
	            * @param   {Function} listener Handler to be removed
	            * @returns {Object}            Chainable methods
	            */
	        off: function off(event, listener) {
	            if (!arguments.length) {
	                this.events = null;
	                return this;
	            } else if (arguments.length === 1) {
	                if (this.events.hasOwnProperty(event)) {
	                    this.events[event] = null;
	                }
	                return this;
	            }

	            var listeners = this.listeners(event);
	            var listenerIndex = indexOf(listeners, listener);

	            if (listenerIndex >= 0) {
	                listeners.splice(listenerIndex, 1);
	            }

	            return this;
	        },

	        emit: emit,

	        /**
	                     * Alias for emit
	                     * {Function}
	                     */
	        trigger: emit,

	        /**
	                        * Adds a one time `listener` for the `event`.
	                        * @param   {String}   event     Name of the event
	                        * @param   {Function} listener  Handler to be added
	                        * @param   {Object}   thisp     Object to be bound to the listener
	                        * @returns {Object}             Chainable method
	                        */
	        once: function once(event, listener, thisp) {
	            var self = this;

	            function one() {
	                self.off(event, one);
	                listener.apply(this, arguments);
	            }

	            one.listener = listener;
	            this.on(event, one, thisp);

	            return this;
	        },

	        /**
	            * Returns an array of listeners for the specified `event`.
	            * @param   {String} event  Name of the event
	            * @returns {Array}
	            */
	        listeners: function listeners(event) {
	            var events = this.events || (this.events = {});

	            return events[event] || (events[event] = []);
	        } };


	    EventEmitter.create = function () {
	        return new EventEmitter();
	    };

	    /**
	        * Adds event emitter functionality to `target`.
	        * @param  {Object} target Object to be mixed
	        */
	    EventEmitter.mixin = function (target) {
	        var props = ['on', 'off', 'emit', 'trigger', 'once', 'listeners'];

	        for (var i = props.length; i--;) {
	            target[props[i]] = EventEmitter.prototype[props[i]];
	        }
	    };

	    module.exports = EventEmitter;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - New York
	               *  Filename : eventpubsub.js
	               *  Description: Pubsub wrapper that prefixes events with channels.
	               *  ----------------------------------------------------------------
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    function EventPubSub() {}

	    EventPubSub.create = function () {
	        return new EventPubSub();
	    };

	    EventPubSub.prototype = {
	        /**
	                               * Add channel that will be used to prefix event names.
	                               */
	        registerChannel: function registerChannel(eventChannel) {
	            this.channel = eventChannel;
	        },

	        /**
	            * Listen to a given event. If channel is set,
	            * then the event name will be prefixed with it.
	            *
	            * @param name {String} Event name
	            * @param callback {Function} Listener
	            */
	        subscribe: function subscribe(name, callback) {
	            var args = Array.prototype.slice.call(arguments);
	            if (this.channel) {
	                args[0] = this.channel + '.' + name;
	            }
	            window.gadgets.pubsub.subscribe.apply(null, args);
	        },

	        /**
	            * Listen to a given event. No channel prefix applied.
	            *
	            * @param name {String} Event name
	            * @param callback {Function} Listener
	            */
	        subscribeGlobal: function subscribeGlobal(name, callback) {
	            var args = Array.prototype.slice.call(arguments);
	            window.gadgets.pubsub.subscribe.apply(null, args);
	        },

	        /**
	            * Publish a given event. If channel is set,
	            * then the event name will be prefixed with it.
	            * NOTE: for backwards compatibility 'arguments' has to be used for now (see provider.js).
	            *
	            * @param name {String} Event name
	            */
	        publish: function publish(name /*, argument1, ..., argumentN*/) {
	            var args = Array.prototype.slice.call(arguments);
	            if (this.channel) {
	                args[0] = this.channel + '.' + name;
	            }
	            window.gadgets.pubsub.publish.apply(null, args);
	        },

	        /**
	            * Publish a given event. No channel prefix applied.
	            * NOTE: for backwards compatibility 'arguments' has to be used for now (see provider.js).
	            *
	            * @param name {String} Event name
	            */
	        publishGlobal: function publishGlobal(name /*, argument1, ..., argumentN*/) {
	            var args = Array.prototype.slice.call(arguments);
	            window.gadgets.pubsub.publish.apply(null, args);
	        },

	        /**
	            * Unsubscribes callback function from a given published event.
	            * If channel is set, then it will search for prefixed event name.
	            *
	            * @param name {String} Event name
	            * @param callback {Function} Listener
	            */
	        unsubscribe: function unsubscribe(name, callback) {
	            var args = Array.prototype.slice.call(arguments);
	            if (this.channel) {
	                args[0] = this.channel + '.' + name;
	            }
	            window.gadgets.pubsub.unsubscribe.apply(null, args);
	        },

	        unsubscribeGlobal: function unsubscribeGlobal(name, callback) {
	            var args = Array.prototype.slice.call(arguments);
	            window.gadgets.pubsub.unsubscribe.apply(null, args);
	        },

	        flush: function flush(name) {
	            var args = Array.prototype.slice.call(arguments);
	            if (this.channel) {
	                args[0] = this.channel + '.' + name;
	            }
	            window.gadgets.pubsub.flush.apply(null, args);
	        },

	        flushGlobal: function flushGlobal(name) {
	            var args = Array.prototype.slice.call(arguments);
	            window.gadgets.pubsub.flush.apply(null, args);
	        } };


	    module.exports = EventPubSub;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               * Provides generic cache system. Use this module to cache async calls.
	               *
	               * @copyright Backbase B.V.
	               * @author Backbase R&D - Amsterdam - New York
	               *
	               * @name cache
	               * @memberof core
	               * @ngModule
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'core.cache';
	    var base = __webpack_require__(3);

	    var portal = __webpack_require__(10);
	    var deps = [
	    portal.name];


	    module.exports = base.createModule(module.name, deps).
	    factory(__webpack_require__(12));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - New York
	               *  Filename : main.js
	               *  Description: module for communication with portal client
	               * ----------------------------------------------------------------
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'core.portal';

	    var base = __webpack_require__(3);

	    var deps = [];


	    // @ngInject
	    function run() {

	    }

	    module.exports = base.createModule(module.name, deps).
	    constant(__webpack_require__(11)) // lpPortal
	    .run(run);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';
	    var utils = __webpack_require__(3).utils;
	    var b$ = window.b$ || {};
	    var portal = utils.assign({
	        portalView: { getElementsByTagName: function getElementsByTagName() {return [];} },
	        config: { serverRoot: './' },
	        pageName: '',
	        pageUUID: '',
	        loggedInUserId: '' },
	    b$.portal);
	    var bd = utils.assign({
	        designMode: false },
	    window.bd);

	    var page = {
	        name: portal.pageName,
	        id: portal.pageUUID };


	    var pageClient = portal.portalView.getElementsByTagName('page')[0];
	    page.getPreference = function (prop) {
	        if (pageClient) {
	            return pageClient.getPreference(prop);
	        }
	    };

	    exports.lpPortal = {
	        root: portal.config.serverRoot,
	        name: portal.portalName,
	        page: page,
	        defaultLandingPage: portal.config.defaultLandingPage,
	        linkId: portal.linkUUID,
	        userId: portal.loggedInUserId,
	        designMode: bd.designMode === 'true',
	        // used by module-accounts: (temporary solution, should be widget preferences)
	        // portal.config.locale - choses the type of IBAN. possible values EU, US, en-US
	        locale: portal.config.locale,
	        // portal.config.hideAccount - if true account no is hidden
	        hideAccount: portal.config.hideAccount,
	        // portal.config.maskAccount - if number only first # will show
	        maskAccount: portal.config.maskAccount,
	        // temporary solution in case that some config value is missing
	        // if you use it, console.log the property that is requested
	        '_portalConfig': portal.config
	        // resourceManager?
	        // noDup is not used anywhere
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var utils = __webpack_require__(3).utils;

	    /** Http cache singleton instance */
	    var httpCache;

	    // @ngInject
	    exports.lpCoreHttpCache = function lpCoreHttpCache($cacheFactory, lpPortal, $timeout) {
	        if (httpCache) {
	            return httpCache;
	        }

	        var invalidateTimeout = parseInt(lpPortal.page.getPreference('httpCacheTimeout'), 10);
	        if (isNaN(invalidateTimeout)) {
	            invalidateTimeout = 0;
	        }

	        httpCache = $cacheFactory('lpHttp');
	        var put = httpCache.put,
	        generated = {},
	        generateRemoveCache = function generateRemoveCache(key) {
	            generated[key] = generated[key] || utils.once(function () {
	                $timeout(function () {
	                    httpCache.remove(key);
	                    delete generated[key];
	                }, invalidateTimeout);
	            });

	            return generated[key];
	        };

	        httpCache.put = function (key) {
	            var result = put.apply(this, arguments),
	            removeCache = generateRemoveCache(key);

	            (result.then || removeCache).call(result, removeCache);
	            return result;
	        };

	        return httpCache;
	    };

	    /** Promise cache singleton instance */
	    var cache;

	    /**
	                * Returns cached promise for the key if it exists.
	                * Otherwise calls the function returning promise, and return it.
	                *
	                * @name lpCoreCachePromise
	                * @memberof core.cache
	                * @param   {Object}  options  Object containing:
	                *   {String} key        Cache key
	                *   {Function} promise  Function returning promise
	                * @returns {Promise}
	                * @ngFactory
	                */
	    function cachePromise(options) {
	        var promise = options.promise;
	        var key = options.key;
	        var promiseCache = cache.get(key);

	        if (!promiseCache) {
	            promiseCache = promise.call();
	            cache.put(key, promiseCache);
	        }

	        return promiseCache;
	    }

	    // @ngInject
	    exports.lpCoreCachePromise = function lpCoreCachePromise($cacheFactory) {
	        cache = cache || $cacheFactory('lp');
	        return cachePromise;
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               * Auto configuration module
	               * @name configuration
	               * @memberof core
	               * @ngModule
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'core.configuration';

	    var base = __webpack_require__(3);
	    var deps = [];

	    /**
	                    * {Description}
	                    * @name lpCoreConfiguration
	                    * @memberof core.configuration
	                    * @ngProvider
	                    * @ngInject
	                    */
	    function configurationProvider(lpCoreUtils, lpCoreI18nProvider) {
	        var widget;
	        var utils = lpCoreUtils;

	        this.useWidgetInstance = function (w) {
	            widget = w;
	            lpCoreI18nProvider.useWidgetInstance(w);
	        };

	        // @ngInject
	        this.$get = function () {
	            /**
	                                  * @alias core.configuration.lpCoreConfiguration
	                                  */
	            var API = function API(setWidget) {
	                this.widget = setWidget;
	                this.attributes = {};

	                this.defineAttribute('locale', {
	                    'default': 'en' });

	            };

	            /**
	                * Returns current value of locale attribute
	                *
	                * @example
	                * ```
	                * var locale = configProvider.getLocale(); // "en"
	                * ```
	                *
	                * @returns {String}
	                */
	            API.prototype.getLocale = function () {
	                return this.get('locale');
	            };

	            /**
	                * Defines a new config attribute with the specified attribute name
	                * and the specified attribute description.
	                *
	                * @example
	                * ```
	                * // Define attribute "permission" and set "readonly" as a default value
	                * configProvider.defineAttribute('permission', {
	                *   'default': 'readonly'
	                * });
	                * ```
	                *
	                * @param attr {String} Attribute name
	                * @param {Object} definition
	                *
	                * @returns {Undefined}
	                */
	            API.prototype.defineAttribute = function (attr, definition) {
	                this.attributes[attr] = definition;
	            };

	            /**
	                * Returns value of the specified attribute.
	                * Returns default value if actual value is undefined.
	                * @param attr {String} Attribute name
	                * @returns {*}
	                */
	            API.prototype.get = function (attr) {
	                var value;
	                if (this.widget) {
	                    value = this.widget.getPreference(attr) || this.widget.getPreferenceFromParents(attr);
	                }

	                value = typeof value !== 'undefined' ? value : this.getDefault(attr);

	                // If the value is a string, the resolve portal client placeholders ($contextRoot, etc).
	                if (utils.isString(value)) {
	                    value = utils.resolvePortalPlaceholders(value);
	                }

	                return value;
	            };

	            /**
	                * Returns default value of the specified attribute or null,
	                * if the attribute doesn't have default value;
	                *
	                * @example
	                * ```
	                * // Read default value for "locale" attribute
	                * var defaultValue = configProvider.getDefault('locale'); // "en"
	                * ```
	                *
	                * @param attr {String} Attribute name
	                * @returns {*|Null}
	                */
	            API.prototype.getDefault = function (attr) {
	                return this.attributes[attr] && this.attributes[attr]['default'] ?
	                this.attributes[attr]['default'] :
	                null;
	            };

	            /**
	                * Returns the ABS path if there is one. Only works if a widget is set, otherwise assumes
	                * ABS path is on the root `/`.
	                * @returns {String}
	                */
	            API.prototype.getAbsPath = function () {
	                return this.widget && utils.getWidgetBaseUrl(this.widget) || '/';
	            };

	            return new API(widget);
	        };
	    }

	    module.exports = base.createModule(module.name, deps).
	    provider('lpCoreConfiguration', configurationProvider);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               * Error handler system. Overrides the default Angular
	               * <a href="https://docs.angularjs.org/api/ng/service/$exceptionHandler">$exceptionHandler</a> action.
	               *
	               * @copyright Backbase B.V.
	               * @author : Backbase R&D - Amsterdam - New York
	               *
	               * @name error
	               * @memberof core
	               * @ngModule
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    module.name = 'error';

	    var base = __webpack_require__(3);

	    var deps = [
	        // no dependencies
	    ];

	    module.exports = base.createModule(module.name, deps).
	    config(__webpack_require__(15)).
	    factory(__webpack_require__(16));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - New York
	               *  Filename : config.js
	               *  Description:
	               *  #TODO filter exceptions
	               *  #TODO use lpCoreBus to emit some specific errors events
	               *  #TODO add method to use custom handler
	               *  ----------------------------------------------------------------
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // @ngInject
	    module.exports = function ($provide) {

	        // module configuration
	        // Decorate the NG exceptionHandler
	        $provide.decorator('$exceptionHandler', function ($delegate, $injector) {
	            return function (e, opts) {
	                // Handle the exception by name and call the propper service
	                //var $log = $injector.get('$log');
	                //$log.debug('Default exception handler:', e.name);
	                $delegate(e, opts);
	            };
	        });
	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // base utility library (lodash + base);
	    var utils = __webpack_require__(3).utils;
	    var API = {};
	    var AssertionError;

	    /**
	                         * lpCoreError API
	                         *
	                         * #####Correctly throwing an error
	                         *
	                         * 1. Errors should be thrown in the low-level parts of the application (**base, core, modules**)
	                         * 2. Always throw an instance of `Error` class, never throw a string or an object. Getting stack trace
	                         *    is only possible via Error object, for example.
	                         * 3. Throwing an error stops code execution. If the error is not serious enough, throw it asynchronously
	                         *
	                         * #####Capture inside the widget
	                         * @example
	                         * ```
	                         * var transaction = lpTransaction.api();
	                         *
	                         * // Widget level
	                         * transaction.save()
	                         *   .catch(lpCoreError.captureException) // basic handling
	                         *   .then(showSuccessMethod)
	                         *   .finally(doneLoading);
	                         * ```
	                         *
	                         * #####Custom Error types in LP
	                         *
	                         * 1. API modules Error types LP{API}Error
	                         *
	                         * ```
	                         * var TransactionError = lpCoreError.createException('LPTransactionError');
	                         * var AccountError = lpCoreError.createException('LPAccountError');
	                         * ```
	                         *
	                         * 2. Core Error types `LPCoreHttp`, `LPCoreI18n`, `LPCoreStore`, `LPCoreBus`, etc.
	                         *
	                         * #####Error types
	                         *
	                         * Besides the generic Error constructor, there are other core error constructors in JavaScript.
	                         * For client-side exceptions, see Exception Handling Statements.
	                         *
	                         * - `EvalError` occurs regarding the global function eval().
	                         * - `InternalError` occurs when an internal error in the JavaScript engine is thrown. E.g. "too much recursion".
	                         * - `RangeError` occurs when a numeric variable or parameter is outside of its valid range.
	                         * - `ReferenceError` occurs when de-referencing an invalid reference.
	                         * - `SyntaxError` occurs while parsing code in eval().
	                         * - `TypeError` occurs when a variable or parameter is not of a valid type.
	                         * - `URIError` occurs when encodeURI() or decodeURI() are called
	                         *
	                         * #####Events / lpCoreBus
	                         *
	                         * ```
	                         * // will publish a notification error event
	                         * lpCoreBus.publish('lp:notify:error', error);
	                         * ```
	                         *
	                         * #####Resources
	                         * - <a target="_blank" href="http://www.slideshare.net/nzakas/enterprise-javascript-error-handling-presentation">
	                         *      http://www.slideshare.net/nzakas/enterprise-javascript-error-handling-presentation</a>
	                         * - <a target="_blank" href="http://eloquentjavascript.net/1st_edition/chapter5.html">
	                         *      http://eloquentjavascript.net/1st_edition/chapter5.html</a>
	                         * - <a target="_blank" href="https://docs.angularjs.org/api/ng/service/$exceptionHandler">
	                         *      https://docs.angularjs.org/api/ng/service/$exceptionHandler</a>
	                         * - <a target="_blank" href="http://blog.loadimpact.com/2014/06/03/exception-handling-in-an-angularjs-web-application-tutorial/">
	                         *      http://blog.loadimpact.com/2014/06/03/exception-handling-in-an-angularjs-web-application-tutorial/</a>
	                         * - <a target="_blank" href="https://technology.amis.nl/2014/10/06/automatic-error-handling-in-angularjs/">
	                         *      https://technology.amis.nl/2014/10/06/automatic-error-handling-in-angularjs/</a>
	                         * - <a target="_blank" href="http://odetocode.com/blogs/scott/archive/2014/04/21/better-error-handling-in-angularjs.aspx">
	                         *      http://odetocode.com/blogs/scott/archive/2014/04/21/better-error-handling-in-angularjs.aspx</a>
	                         * - <a target="_blank" href="http://bahmutov.calepin.co/catch-all-errors-in-angular-app.html">
	                         *      http://bahmutov.calepin.co/catch-all-errors-in-angular-app.html</a>
	                         * - <a target="_blank" href="http://www.nczonline.net/blog/2009/03/03/the-art-of-throwing-javascript-errors/">
	                         *      http://www.nczonline.net/blog/2009/03/03/the-art-of-throwing-javascript-errors/</a>
	                         *
	                         * @memberof core.error
	                         * @ngFactory
	                         * @ngInject
	                         */
	    exports.lpCoreError = function ($exceptionHandler, $q) {
	        /**
	                                                             * Creates a custom Error Exception
	                                                             * @param   {String} name  Exception name
	                                                             * @returns {Object}       ErrorCustomException constructor
	                                                             */
	        API.createException = function (name) {
	            function ErrorException(message) {
	                this.name = name || 'Error';
	                this.message = message || 'Unknown Message';
	            }

	            ErrorException.prototype = new Error();
	            ErrorException.prototype.constructor = ErrorException;

	            return ErrorException;
	        };

	        /**
	            * Captures the exception and pass it to Angular exceptionHandler.
	            *
	            * @example
	            * Used in a `try-catch` block:
	            *
	            * ```
	            * try {
	            *   someUnpredictableMethod();
	            * } catch(error) {
	            *   lpCoreError.captureException(error);
	            * }
	            * ```
	            *
	            * @example
	            * Used in a `Promise`:
	            *
	            * ```
	            * someAsyncThing()
	            *   .then(someOtherAsyncThing)
	            *   .catch(function (error) {
	            *     lpCoreError.captureException(error);
	            *   });
	            * ```
	            *
	            * @example
	            * Also you can pass extra data:
	            *
	            * ```
	            * lpCoreError.captureException(error, {
	            *   some: 'option'
	            * });
	            * ```
	            *
	            * @memberof core.error.lpCoreError
	            * @param   {Error}  error  Exception
	            * @param   {Object} opts   Optional cause/options/context
	            * @returns {Object} Angular Error Object
	            */
	        API.captureException = function (error, opts) {
	            return $exceptionHandler(error, opts);
	        };

	        /**
	            * Throws the error.
	            *
	            * @example
	            * Throwing normal Error object (not recommended):
	            *
	            * ```
	            * exports.MainCtrl = function(lpCoreError) {
	            *   if (somethingWrong) {
	            *     lpCoreError.throwException('Normal Error');
	            *   }
	            * }
	            * ```
	            *
	            * This will throw an exception.name of type Error
	            * which will be caught by the **$exceptionHandler**
	            *
	            * @example
	            * Throwing your own exceptions (recommended, categorized exceptions):
	            *
	            * ```
	            * // Create a custom exception Error with Widgets.SampleWidget as name
	            * var WidgetErrorException = lpCoreError.createException('WidgetError');
	            *
	            * exports.MainCtrl = function(lpCoreError) {
	            *   if (somethingWrong) {
	            *     lpCoreError.throwException(new WidgetErrorException('Something wrong'));
	            *   }
	            * }
	            * ```
	            *
	            * This will throw an exception.name of type **WidgetError**
	            *
	            * @example
	            * Throwing errors in promises:
	            *
	            * ```
	            * var someOtherAsyncThing = function() {
	            *   return new Promise(function(resolve, reject) {
	            *     lpCoreError.throwException(new WidgetErrorException('Something wrong'));
	            *   });
	            * };
	            * ```
	            *
	            * You don't need to use reject method.
	            *
	            * @memberof core.error.lpCoreError
	            * @param error {Error|String} Error message or exception instance
	            * @returns {Undefined}
	            */
	        API.throwException = function (error) {
	            if (!(error instanceof Error)) {
	                error = new Error(error);
	            }
	            throw error;
	        };

	        /**
	            * Throws Error asynchronously.
	            * Throwing an error stops code execution.
	            * If the error is not serious enough, throw it asynchronously
	            *
	            * @memberof core.error.lpCoreError
	            * @param   {Error}     error  Error message or exception instance
	            * @param   {Number}    delay  Execution delay
	            * @param   {Object}    args   Arguments for the delay method
	            * @returns {Undefined}
	            */
	        API.throwExceptionAsync = function (error, delay, args) {
	            if (!(error instanceof Error)) {
	                error = new Error(error);
	            }
	            utils.defer(function () {throw error;}, delay || 100, args);
	        };

	        /**
	            * Throws an AssertionError if condition is not satisfied.
	            * Supposed to be a standardized way for programs to test invariants.
	            *
	            * @example
	            * ```
	            * lpCoreError.assert(x === 12); // throws an AssertionError if false, with a default error message
	            * lpCoreError.assert(x === 12, 'I think it should be twelve') // throws an AssertionError if false, with the given error message
	            * ```
	            *
	            * @memberof core.error.lpCoreError
	            * @param   {Boolean}   condition  Evaluate condition
	            * @param   {String}    message    Error message
	            * @returns {Undefined}
	            */
	        API.assert = function (condition, message) {
	            AssertionError = AssertionError || API.createException('AssertionError');
	            if (!condition) {
	                API.throwException(new AssertionError(message || 'Assertion fails!'));
	            }
	        };

	        return API;
	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               * Main lpCoreHttp module
	               *
	               * @copyright Backbase B.V.
	               * @author Backbase R&D - Amsterdam - New York
	               *
	               * @name http
	               * @memberof core
	               * @ngModule
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'http';

	    var base = __webpack_require__(3);
	    // 3rd Party
	    // Add angular ressources after base
	    __webpack_require__(18);

	    var cache = __webpack_require__(9);

	    // module dependencies
	    var deps = [
	    'ngResource',
	    cache.name];


	    // @ngInject
	    function run($http, lpCoreHttpCache) {
	        $http.defaults.cache = lpCoreHttpCache;
	    }

	    module.exports = base.createModule(module.name, deps).
	    config(__webpack_require__(19)).
	    factory(__webpack_require__(31)).
	    run(run);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_18__;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - New York
	               *  Filename : config.js
	               *  Description: http Configuration Module
	               *  ----------------------------------------------------------------
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var base = __webpack_require__(3);
	    var $ = __webpack_require__(20);
	    var utils = __webpack_require__(21);

	    var $injector = base.ng.injector([utils.name]);
	    var lpCoreUtils = $injector.get('lpCoreUtils');

	    var xsrfTokenCookie = lpCoreUtils.getCookie('XSRF-TOKEN');

	    // set xsrf token for non-angular XHR requests
	    // Configure global XHR requests using jQuery
	    if (xsrfTokenCookie !== '') {
	        $.ajaxSetup({
	            global: true,
	            headers: { 'X-XSRF-TOKEN': xsrfTokenCookie } });

	    }

	    var fromJson = base.ng.fromJson;
	    var isString = base.ng.isString;
	    var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	    var JSON_START = /^\[|^\{(?!\{)/;
	    var JSON_ENDS = {
	        '[': /]$/,
	        '{': /}$/ };

	    var APPLICATION_JSON = 'application/json';

	    function httpResponseTransform(data, headers) {
	        if (isString(data)) {
	            // Strip json vulnerability protection prefix and trim whitespace
	            var tempData = data.replace(PROTECTION_PREFIX, '').trim();
	            if (tempData) {
	                // Based on angular source https://github.com/angular/angular.js/commit/b9bdbe615cc4070d2233ff06830a4c6fb1217cda#diff-748e0a1e1a7db3458d5f95d59d7e16c9R15
	                var jsonStart = tempData.match(JSON_START);
	                if (jsonStart && JSON_ENDS[jsonStart[0]].test(tempData)) {
	                    data = fromJson(tempData);
	                }
	            }
	        }

	        return data;
	    }

	    /**
	       * [httpConfig description]
	       * @param $httpProvider
	       * @param $provide
	       * @returns {*}
	       */
	    // @ngInject
	    module.exports = function ($httpProvider) {
	        // create the interceptor factory
	        $httpProvider.interceptors.push('lpCoreHttpInterceptor');
	        var defaultHeaders = {
	            'Accept': 'application/json',
	            'Content-Type': 'application/json',
	            'X-XSRF-TOKEN': xsrfTokenCookie };

	        $httpProvider.defaults.headers.common = defaultHeaders;
	        $httpProvider.defaults.headers.post = defaultHeaders;
	        $httpProvider.defaults.headers.put = defaultHeaders;
	        //* #TODO add general $resourceProvider.defaults

	        $httpProvider.defaults.transformResponse = [httpResponseTransform];
	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               * Core utilities module exposed as `lpCoreUtils` angular constant object.
	               * @name utils
	               * @memberof core
	               * @ngModule
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	  'use strict';

	  module.name = 'core.utils';

	  var base = __webpack_require__(3);

	  /**
	                               * @name lpCoreUtils
	                               * @memberof core.utils
	                               * @ngConstant
	                               */
	  var utils = base.utils;

	  var url = __webpack_require__(22);
	  var date = __webpack_require__(23);
	  var portal = __webpack_require__(25);
	  var is = __webpack_require__(26);
	  var parse = __webpack_require__(27);
	  var string = __webpack_require__(28);
	  var cookie = __webpack_require__(29);
	  var ngUtils = __webpack_require__(30);

	  utils.mixin(url);
	  utils.mixin(date);
	  utils.mixin(portal);
	  utils.mixin(is);
	  utils.mixin(parse);
	  utils.mixin(string);
	  utils.mixin(cookie);
	  utils.mixin(ngUtils);

	  module.exports = base.createModule(module.name, []).
	  constant({ 'lpCoreUtils': utils });
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Parses / stringifies query string
	               * @module url
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var utils = __webpack_require__(3).utils;

	    /**
	                                        * Given a `string` returns the json `object` equivalent.
	                                        *
	                                        * @memberof core.utils.lpCoreUtils
	                                        * @param   {String} str  The query string
	                                        * @returns {Object} Returns a json object
	                                        */
	    exports.parseQuerystring = function parseQuerystring(str) {
	        if (!utils.isString(str)) {
	            return {};
	        }

	        str = utils.trim(str);

	        if (!str) {
	            return {};
	        }

	        return utils.reduce(str.split('&'), function (obj, param) {
	            var parts = param.split('=');
	            var key = decodeURIComponent(parts[0]);
	            var val = parts[1];

	            val = utils.isUndefined(val) ? null : decodeURIComponent(val);

	            if (obj.hasOwnProperty(key)) {
	                if (!utils.isArray(obj[key])) {
	                    obj[key] = [obj[key]];
	                }
	                obj[key].push(val);
	            } else {
	                obj[key] = val;
	            }

	            return obj;
	        }, {});
	    };

	    /**
	        * Given an `object` returns its query string equivalent.
	        *
	        * @example
	        * ```
	        * lpCoreUtils.buildQueryString({
	        *   search: 'backbase',
	        *   page: 3
	        * }); // "search=backbase&page=3"
	        * ```
	        *
	        * @memberof core.utils.lpCoreUtils
	        * @param   {Object} obj  A json compliant object
	        * @returns {String} Returns the query string
	        */
	    exports.buildQueryString = function buildQueryString(obj) {
	        if (!utils.isObject(obj)) {
	            return '';
	        }

	        return utils.map(utils.keys(obj), function (key) {
	            var val = obj[key];

	            if (utils.isArray(val)) {
	                return utils.map(val, function (val2) {
	                    return encodeURIComponent(key) + '=' + encodeURIComponent(val2);
	                }).join('&');
	            }

	            return encodeURIComponent(key) + '=' + encodeURIComponent(val);
	        }).join('&');
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Missing methods in the Date native object and extensions.
	               * @module date
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var utils = __webpack_require__(3).utils;
	    var pad = function pad(number) {
	        return utils.padLeft(number, 2, '0');
	    };

	    /**
	        * Exposes <a href="http://momentjs.com/docs/" target="_blank">momentjs</a> object.
	        *
	        * @memberof core.utils.lpCoreUtils
	        * @example
	        * ```
	        * var date = lpCoreUtils.date().format('dddd, MMMM Do YYYY, h:mm:ss a');
	        * console.log(date); // "Sunday, February 14th 2010, 3:25:50 pm"
	        * ```
	        */
	    exports.date = __webpack_require__(24);

	    /**
	                                       * Returns a string in ISO format, `YYYY-MM-DDTHH:mm:ss.sssZ`, UTC format.
	                                       *
	                                       * @memberof core.utils.lpCoreUtils
	                                       * @param   {Date}   date  The input date
	                                       * @returns {String}       The ISO string representation.
	                                       */
	    exports.dateToISOString = function (date) {
	        if (Date.prototype.toISOString) {
	            return Date.prototype.toISOString.call(date);
	        }

	        /** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString */
	        return date.getUTCFullYear() +
	        '-' + pad(date.getUTCMonth() + 1) +
	        '-' + pad(date.getUTCDate()) +
	        'T' + pad(date.getUTCHours()) +
	        ':' + pad(date.getUTCMinutes()) +
	        ':' + pad(date.getUTCSeconds()) +
	        '.' + (date.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) +
	        'Z';
	    };

	    exports.dateFormat = function (date, options) {};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_24__;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Utility methods to assign with portal.
	               * @module string
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(3);
	    var lpPortal = base.inject('lpPortal', __webpack_require__(10).name);
	    var utils = base.utils;

	    /**
	                             * Resolve portal client placeholders.
	                             *
	                             * @example
	                             * ```
	                             * lpCoreUtils.resolvePortalPlaceholders('$(contextPath)/some/page.html'); // "/real/context/path/some/page.html"
	                             * ```
	                             *
	                             * @memberof core.utils.lpCoreUtils
	                             * @param   {String} string Path to be resolved
	                             * @returns {String}
	                             */
	    exports.resolvePortalPlaceholders = function (string) {
	        if (!utils.isString(string)) {
	            return string;
	        }

	        var replaceWith = lpPortal.root || '';
	        var replacements = utils([
	        '$(contextRoot)',
	        '$(contextPath)',
	        '$(servicesPath)']);


	        string = replacements.reduce(function (str, replace) {
	            return str.replace(replace, replaceWith);
	        }, string);

	        string = string.replace('[BBHOST]', '%5BBBHOST%5D');

	        return string;
	    };

	    /**
	        * Returns the base URL of the given widget instance.
	        *
	        * @memberof core.utils.lpCoreUtils
	        * @param   {Widget} widgetInstance Instance of the widget
	        * @returns {String}
	        */
	    exports.getWidgetBaseUrl = function (widgetInstance) {
	        if (!utils.isEmpty(widgetInstance)) {
	            var src = widgetInstance.getPreference('src');
	            return src && exports.resolvePortalPlaceholders(
	            src.replace(/\/[^\/]*$/, ''));

	        }
	    };

	    /**
	        * Return value of the portal configuration property
	        * @memberof core.utils.lpCoreUtils
	        * @param   {String} property  Name of the portal property
	        * @returns {String}           Value of the portal property
	        */
	    // TODO: remove this method after refactoring MFALogin to use lpPortal
	    exports.getPortalProperty = function (property) {
	        switch (property) {
	            case 'serverRoot':
	                return lpPortal.root;
	            case 'portalName':
	                return lpPortal.name;
	            case 'pageName':
	                return lpPortal.page.name;
	            case 'defaultLandingPage':
	                return lpPortal.defaultLandingPage;
	            case 'locale':
	                return lpPortal.locale;
	            case 'hideAccount':
	                return lpPortal.hideAccount;
	            case 'maskAccount':
	                return lpPortal.maskAccount;
	            default:
	                return lpPortal['_portalConfig'][property];}

	    };

	    /**
	        * Returns value of the page configuration preference
	        * @memberof core.utils.lpCoreUtils
	        * @param   {String} prop  Name of the page property
	        * @returns {String}       Value of the page property
	        */
	    exports.getPagePreference = function (prop) {
	        return lpPortal.page.getPreference(prop);
	    };

	    /**
	        * Returns the portal page element
	        * @memberof core.utils.lpCoreUtils
	        * @returns {Element}
	        */
	    exports.getPortalPage = function () {
	        return lpPortal.page;
	    };

	    exports.generateUUID = function () {

	        var d = new Date().getTime();
	        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	            var r = (d + Math.random() * 16) % 16 | 0;
	            d = Math.floor(d / 16);
	            return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
	        });
	        return uuid;
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Testing methods.
	               * @module is
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    /**
	                   * Check if input is valid email address.
	                   *
	                   * @memberof core.utils.lpCoreUtils
	                   * @param   {String}  email  Email address
	                   * @returns {Boolean}
	                   */
	    exports.isValidEmail = function (email) {
	        var regularExpressions = /^\w+([\.\-]?\w+)*@\w+([\.\-]?\w+)*(\.\w+)+$/;
	        return regularExpressions.test(email);
	    };

	    /**
	        * Check if string is valid UUID
	        *
	        * @memberof core.utils.lpCoreUtils
	        * @param   {String}  string
	        * @returns {Boolean}
	        */
	    exports.isValidUUID = function (string) {
	        var regularExpressions = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
	        return regularExpressions.test(string);
	    };

	    /**
	        * Validate the payment detail checksum based on ISO 7064
	        * http://en.wikipedia.org/wiki/International_Bank_Account_Number#Validating_the_IBAN
	        * @param  {String} input the input to be validated
	        */
	    exports.isValidISO7064Checksum = function (input) {
	        /**
	                                                       * Replace letters from the IBAN with numbers
	                                                       * @param  {String} str [description]
	                                                       */
	        var replaceLetters = function replaceLetters(str) {
	            var strArray = str.split('');
	            for (var i = 0; i < strArray.length; i++) {
	                if (/[A-Z]/.test(strArray[i])) {
	                    strArray[i] = strArray[i].charCodeAt(0) - 55;
	                }
	            }
	            return strArray.join('');
	        };

	        /**
	            * Performs a basic mod-97 operation for IBAN validation (as described in ISO 7064)
	            * @param  {String} str Max 9 character string respresenting part of the IBAN
	            */
	        var mod97 = function mod97(str) {
	            var result = parseInt(str, 10) % 97;
	            result = result.toString();

	            return result.length === 1 ? '0' + result : result;
	        };

	        if (input) {
	            input = input.substr(4) + input.substr(0, 4);
	            input = replaceLetters(input);
	            //bypasses javascript INT32 restriction
	            while (input.length > 2 && !isNaN(input)) {
	                input = mod97(input.substr(0, 9)) + input.substr(9);
	            }
	            if (parseInt(input, 10) === 1) {
	                return true;
	            }
	        }

	        return false;
	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Parsing methods.
	               * @module parse
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	  'use strict';

	  /**
	                 * Normalizes boolean values, to be real Boolean type.
	                 *
	                 * @example
	                 * ```
	                 * lpCoreUtils.parseBoolean(''); // false
	                 * ```
	                 *
	                 * @memberof core.utils.lpCoreUtils
	                 * @param    {String|Boolean|Number} val
	                 * @returns  {Boolean}
	                 */
	  exports.parseBoolean = function (val) {
	    return typeof val === 'boolean' && val ||
	    typeof val === 'string' && /\s*true\s*/i.test(val) ||
	    typeof val === 'number' && val !== 0;
	  };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * String helper methods.
	               * @module utils
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var utils = __webpack_require__(3).utils;

	    /**
	                                        * Removes all the html tags from `str`.
	                                        * @memberof core.utils.lpCoreUtils
	                                        * @param   {String} str  Input string
	                                        * @returns {String}
	                                        */
	    exports.stripHtml = function (str) {
	        if (!utils.isString(str)) {
	            // TODO: use custom log object when implemented
	            console.log(str + ' is not a String');
	            return '';
	        }

	        return str.replace(/<\/?[^>]+>/g, '');
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Cookie helper methods.
	               * @module utils
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    /**
	                   * Returns cookie by name
	                   *
	                   * @memberof core.utils.lpCoreUtils
	                   * @param   {String} name Name of a cookie
	                   * @returns {String}
	                   */
	    exports.getCookie = function (name) {
	        var value = '; ' + document.cookie,
	        parts = '';

	        if (typeof name === 'string') {
	            parts = value.split('; ' + name + '=');
	            if (parts.length === 2) {
	                return parts.pop().split(';').shift();
	            }
	        }
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Helper angular methods.
	               * @module ng
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    /**
	                   * Executes angular digest on the given scope
	                   * if it's not already being executed.
	                   * Then invokes the function `fn`.
	                   *
	                   * @memberof core.utils.lpCoreUtils
	                   * @param   {Object}  scope  Check digest phase in given `scope`
	                   * @param   {Function} fn  Function to execute
	                   */
	    exports.safeApply = function safeApply(scope, fn) {
	        var phase = scope.$root.$$phase;
	        if (phase === '$apply' || phase === '$digest') {
	            fn();
	        } else {
	            scope.$apply(fn());
	        }
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - New York
	               *  Filename : httpInterceptor.js
	               *  Description: Launchpad Http Interceptor
	               *  ----------------------------------------------------------------
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var $ = __webpack_require__(20);
	    var base = __webpack_require__(3);
	    var utils = base.utils;
	    var queue = base.queue;
	    var ignoreList = [];
	    // HTTP Error status code that ignore to be notifiable
	    var ignoredStatusCode = [400, 401, 403];

	    /**
	                                              * Accepts 1..n objects and the last argument must be the key. Starts
	                                              * searching for the key in the first object and so on until it is found,
	                                              * then return that value and deletes that property from the object.
	                                              * @private
	                                              * @param   {...Object} objects
	                                              * @param   {String}    key      Last argument
	                                              * @returns {*} First value found in `objects` by the `key`.
	                                              */
	    var getValue = function getValue() /*objects, key*/{
	        var objects = [].slice.call(arguments);
	        var key = objects.pop();
	        var value;

	        for (var i = 0, len = objects.length; i < len; i++) {
	            if (objects[i].hasOwnProperty(key)) {
	                value = objects[i][key];
	                delete objects[i][key];
	                return value;
	            }
	        }
	    };

	    /**
	        * Replaces `url` string ocurrences of $(property_name) with the values
	        * of `property_name` in `data` and `params` objects. If it is found the
	        * property is deleted from the object. It will start searching in `data`
	        * and then in `params`.
	        * @private
	        * @param   {String} url
	        * @param   {Object} data
	        * @param   {Object} params
	        * @returns {String}
	        */
	    var interpolateUrl = function interpolateUrl(url, data, params) {
	        url = utils.trim(url).replace(
	        /\$\(([a-z]\w*)\)/gi,
	        function ($0, label) {
	            return getValue(data, params, label);
	        });

	        return url;
	    };

	    /**
	        * Check if current response is notifiable.
	        * @private
	        */
	    var isNotifyable = function isNotifyable(response) {
	        var url = response.config.url;
	        return !ignoreList.some(function (pattern) {
	            return pattern instanceof RegExp ? pattern.test(url) : url.indexOf(pattern) > -1;
	        });
	    };

	    /**
	        * Calculate context id from request object. Used to compare "similar" requests and group them in retry dialog.
	        * @private
	        * @param response
	        * @return {string}
	        */
	    var getContextId = function getContextId(response) {
	        return [
	        response.config.method,
	        response.config.url,
	        $.param(response.config.params)].
	        join('__');
	    };


	    /**
	        * Request/Response http interceptor
	        * @memberof core.http
	        * @ngFactory
	        * @ngInject
	        */
	    exports.lpCoreHttpInterceptor = function httpInterceptor($injector, $q) {


	        /**
	                                                                              * Interceptors get called with a http config object.
	                                                                              * The function is free to modify the config object or create a new one.
	                                                                              * The function needs to return the config object directly,
	                                                                              * or a promise containing the config or a new config object.
	                                                                              * @alias request
	                                                                              * @memberof core.http.lpCoreHttpInterceptor
	                                                                              * @param config {Object} Original request configuration
	                                                                              * @returns {Object} Modified request configuration
	                                                                              */
	        function requestInterceptor(config) {
	            config.data = config.data || {};
	            config.params = config.params || {};

	            // replaces all url parameters
	            config.url = interpolateUrl(config.url, config.data, config.params);

	            return config;
	        }

	        /**
	           * Interceptor gets called when a previous interceptor threw an error or resolved with a rejection.
	           * @alias requestError
	           * @memberof core.http.lpCoreHttpInterceptor
	           * @param responseErr {Object} Response http error
	           * @returns {Object} Modified response
	           */
	        function requestErrorInterceptor(responseErr) {
	            // not modified
	            return $q.reject(responseErr);
	        }
	        /**
	           * Interceptors get called with http response object.
	           * The function is free to modify the response object or create a new one.
	           * The function needs to return the response object directly,
	           * or as a promise containing the response or a new response object.
	           * @alias response
	           * @memberof core.http.lpCoreHttpInterceptor
	           * @param response {Object} HTTP response
	           * @returns {Object} Modified response
	           */
	        function responseInterceptor(response) {
	            // not modified
	            return response || $q.when(response);
	        }

	        /**
	           * Interceptor gets called when a previous interceptor threw an error or resolved with a rejection.
	           * @alias responseError
	           * @memberof core.http.lpCoreHttpInterceptor
	           * @param responseErr {Object} Response http error
	           * @returns {Object} Modified response error
	           */
	        function responseErrorInterceptor(responseErr) {
	            // Don't handle 404's
	            if (responseErr.status && responseErr.status !== 404) {

	                if (typeof responseErr.data !== 'string') {
	                    responseErr.data = responseErr.data || {};
	                } else
	                {
	                    // is string so we should not care for now
	                    // should be an object
	                    responseErr.data = {};
	                }
	                responseErr.data.errors = responseErr.data.errors || [];
	                // if endpoint doesn't provide any errors
	                // we create it and add the statusText if any
	                // otherwise 'unknown error message' key
	                var errors = responseErr.data.errors;
	                if (errors.length <= 0) {
	                    errors.push({
	                        code: responseErr.status,
	                        message: responseErr.statusText || 'Unknown error message' });

	                }


	                // ignore 400, 401 and 403 for being notifiable
	                if (utils.indexOf(ignoredStatusCode, responseErr.status) === -1) {
	                    if (isNotifyable(responseErr)) {
	                        var context = {
	                            contextId: getContextId(responseErr),
	                            messages: responseErr.data.errors };

	                        queue.push(context, function retryFunction() {
	                            return $injector.get('$http')(responseErr.config);
	                        });
	                    }
	                }
	            }

	            return $q.reject(responseErr);
	        }

	        /**
	           * Configuring of responseError interceptor notification behavior.
	           * Widgets have ability to prevent notifications from poping up for certain endpoints.
	           * @memberOf core.http.lpCoreHttpInterceptor
	           * @param {Object} params - Configuration of the notifications and retry queue.
	           * @param {Array} params.ignore - Array of urls or regular expression patters responseError interseptor will use to decide whether to show notification or not.
	           * @example Here is the example of how widget can configure interceptor to ignore accounts and debit accounts modules service error, as well as an example of regular expression pattern:
	           *
	           * ```
	           * lpCoreHttpInterceptor.configureNotifications({
	           *     ignore: [
	           *         widget.getPreference('accountsDataSrc'),
	           *         '$(servicesPath)/services/rest/v1/debit-accounts',
	           *         /services\/profile\/.+?/
	           *     ]
	           * });
	           * ```
	           *
	           * Ignore array can contain of simple URL strings or regular expression patterns. Placeholders like `$(servicesPath)` and `$(contextRoot)` are substituted automatically.
	           */
	        function configureNotifications(params) {
	            if (params.ignore) {
	                params.ignore = params.ignore.map(function (pattern) {
	                    return pattern instanceof RegExp ? pattern : utils.resolvePortalPlaceholders(pattern);
	                });
	                ignoreList = ignoreList.concat(params.ignore);
	            }
	        }

	        return {
	            configureNotifications: configureNotifications,
	            request: requestInterceptor,
	            requestError: requestErrorInterceptor,
	            response: responseInterceptor,
	            responseError: responseErrorInterceptor };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               * This module is responsible for internationalisation of all Launchpad widgets.
	               *
	               * #####Configuration
	               *
	               * External settings that are passed to it are:
	               *
	               * - `locale` – <a href="http://www.w3.org/TR/html401/struct/dirlang.html#h-8.1.1">Language code</a>.
	               * Read from the lang attribute of html tag of the page.
	               * If lang attribute is not defined, fallbacks to browser's default language.
	               * You can change locale on the fly by publishing `lpCoreI18nUtils.LOCALE_CHANGE_EVENT`
	               *
	               * - `path` – Path where common translation files and angular locale files are stored.
	               * Default path is `$(contextRoot)/static/launchpad/modules/config/i18n`
	               *
	               * - `mergedFiles` – Used to determine if translation files are merged
	               * into one (one common and one per widget) or every language is separated in it's own file.
	               * Default value is `true` (files are merged)
	               *
	               * Backend is responsible for determining the right locale and printing it as a value of `html.lang` attribute.
	               * It is doing so in the following order:
	               *
	               * 1. If present, then return launchpad user(party) preference `lpLocale`.
	               * 2. If present, then return page preference `lpLocale`.
	               * 3. If present, then return portal preference `lpLocale`.
	               * 4. If present, then return value of `launchpad.defaultLocale` defined in `backbase.properties`.
	               *
	               * To change the `path` and `mergedFiles` settings, create i18n object with those keys
	               * on global window.launchpad object, for example:
	               *
	               * ```
	               * window.launchpad = {
	               *   i18n: {
	               *     path: 'bower_components/config/i18n',
	               *     mergedFiles: false
	               *   }
	               * }
	               * ```
	               *
	               * Path to <a href="https://github.com/angular/angular.js/tree/master/src/ngLocale" target="_blank">angular locale files</a>
	               * is built like: `path + '/ng-locale/angular-locale_{locale}.js'`,
	               * where `{locale}` is replaced with current locale string.
	               *
	               * Every Launchpad widgets contains property `locale` (accessible in Portal Manager).
	               * This property is used just to enable/disable i18n support.
	               * If there is no value, widget will not be initialized for i18n support.
	               * Any value will enable i18n but it is never used internally.
	               *
	               * #####Translation files
	               *
	               * Widget translation strings are defined inside `locale/all.json` in widget's directory
	               * and in `i18n.path/common.json` file. This applies when `mergedFiles` setting is set to true,
	               * otherwise, each laguage will have it's own file in the same location.
	               * Translation file can look like this:
	               *
	               * ```
	               * {
	               *   "nl-NL": {
	               *     "Enrol for Estatements": "Schrijf je in voor eStatements",
	               *     "Statement as of": "Verklaring als van"
	               *   },
	               *
	               *   "ru-RU": {
	               *     "Enrol for Estatements": "Получать отчеты",
	               *     "Statement as of": "Отчет за"
	               *   }
	               * }
	               * ```
	               *
	               * #####Translation
	               * To translate string used in Launchpad Widget html template, use angular tranlate filter:
	               *
	               * ```
	               * <span>{{'Statement as of'|translate}}</span>
	               * ```
	               *
	               * or lp-i18n directive described below.
	               *
	               * #####Enable i18n Language Switching in the UI
	               * To Enable i18n Language Switching in the UI, follow the below instructions to add a preference to a widget.
	               * 1. Open the PortalManager.
	               * 2. Navigate the Explorer to `Portals > Retail-banking > Items > Home`.
	               * 3. Select "widget-navbar-advanced..".
	               * 4. Select the "Properties" tab.
	               * 5. Activate the add property button "+".
	               * 6. In the "Create Preference" modal set.
	               *  1. Name to locales.
	               *  2. Label to locales.
	               *  3. Value to en-US,nl-NL  (comma separated list of languages).
	               * 7. Click save and now in the Client Portal a language menu should appear.
	               *
	               * Note: the language preference is not saved in a session.
	               *
	               *
	               * @copyright Backbase B.V.
	               * @author Backbase R&D - Amsterdam - New York
	               *
	               * #####References</h4>
	               *
	               * - <a target="_blank" href="http://angular-translate.github.io/">
	               *       http://angular-translate.github.io/</a>
	               * - <a target="_blank" href="https://hacks.mozilla.org/2014/12/introducing-the-javascript-internationalization-api">
	               *       https://hacks.mozilla.org/2014/12/introducing-the-javascript-internationalization-api</a>
	               *
	               * @name i18n
	               * @memberof core
	               * @ngModule
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'core.i18n';

	    var base = __webpack_require__(3);
	    // 3rd party modules
	    __webpack_require__(33);
	    __webpack_require__(34);
	    __webpack_require__(35);

	    // some core modules
	    var utils = __webpack_require__(21);
	    var bus = __webpack_require__(4);
	    var error = __webpack_require__(14);
	    var cache = __webpack_require__(9);

	    var deps = [
	    'pascalprecht.translate',
	    'tmh.dynamicLocale',
	    'ngSanitize',
	    utils.name,
	    error.name,
	    cache.name,
	    bus.name];


	    // @ngInject
	    function run(lpCoreBus, lpCoreI18n, lpCoreI18nUtils) {

	        lpCoreBus.subscribe(lpCoreI18nUtils.LOCALE_CHANGE_EVENT, function (locale) {
	            lpCoreI18n.setLocale(locale);
	        });
	    }

	    module.exports = base.createModule(module.name, deps).
	    value('lpI18nCommonTranslation') // common translations stored in loader factory
	    .constant(__webpack_require__(36)) // lpCoreI18nUtils
	    .factory(__webpack_require__(37)) // lpCoreI18nLoader
	    .provider(__webpack_require__(38)) // lpCoreI18n
	    .filter(__webpack_require__(39)) // currencySymbol
	    .directive(__webpack_require__(40)) // lp-i18n & lp-i18n-switch
	    .factory(__webpack_require__(41)) // exposes i18nUtils.loadMessages
	    .directive(__webpack_require__(42)) // contains lp-message directive
	    .run(run);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_33__;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_34__;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_35__;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var CURRENCY_MAP = {
	        'ALL': 'Lek',
	        'AFN': '؋',
	        'ARS': '$',
	        'AWG': 'ƒ',
	        'AUD': '$',
	        'AZN': 'ман',
	        'BSD': '$',
	        'BBD': '$',
	        'BYR': 'p.',
	        'BZD': 'BZ$',
	        'BMD': '$',
	        'BOB': '$b',
	        'BAM': 'KM',
	        'BWP': 'P',
	        'BGN': 'лв',
	        'BRL': 'R$',
	        'BND': '$',
	        'KHR': '៛',
	        'CAD': '$',
	        'KYD': '$',
	        'CLP': '$',
	        'CNY': '¥',
	        'COP': '$',
	        'CRC': '₡',
	        'HRK': 'kn',
	        'CUP': '₱',
	        'CZK': 'Kč',
	        'DKK': 'kr',
	        'DOP': 'RD$',
	        'XCD': '$',
	        'EGP': '£',
	        'SVC': '$',
	        'EEK': 'kr',
	        'EUR': '€',
	        'FKP': '£',
	        'FJD': '$',
	        'GHC': '¢',
	        'GIP': '£',
	        'GTQ': 'Q',
	        'GGP': '£',
	        'GYD': '',
	        'HNL': 'L',
	        'HKD': '$',
	        'HUF': 'Ft',
	        'ISK': 'kr',
	        'IDR': 'Rp',
	        'IRR': '﷼',
	        'IMP': '£',
	        'ILS': '₪',
	        'JMD': 'J$',
	        'JPY': '¥',
	        'JEP': '£',
	        'KZT': 'лв',
	        'KGS': 'лв',
	        'LAK': '₭',
	        'LVL': 'Ls',
	        'LBP': '£',
	        'LRD': '$',
	        'LTL': 'Lt',
	        'MKD': 'ден',
	        'MYR': 'RM',
	        'MUR': '₨',
	        'MXN': '$',
	        'MNT': '₮',
	        'MZN': 'MT',
	        'NAD': '$',
	        'NPR': '₨',
	        'ANG': 'ƒ',
	        'NZD': '$',
	        'NIO': 'C$',
	        'NGN': '₦',
	        'KPW': '₩',
	        'NOK': 'kr',
	        'OMR': '﷼',
	        'PKR': '₨',
	        'PAB': 'B/.',
	        'PYG': 'Gs',
	        'PEN': 'S/.',
	        'PHP': '₱',
	        'PLN': 'zł',
	        'QAR': '﷼',
	        'RON': 'lei',
	        'RUB': 'руб',
	        'SHP': '£',
	        'SAR': '﷼',
	        'RSD': 'Дин.',
	        'SCR': '₨',
	        'SGD': '$',
	        'SBD': '$',
	        'SOS': 'S',
	        'ZAR': 'R',
	        'KRW': '₩',
	        'LKR': '₨',
	        'SEK': 'kr',
	        'CHF': 'CHF',
	        'SRD': '$',
	        'SYP': '£',
	        'TWD': 'NT$',
	        'THB': '฿',
	        'TTD': 'TT$',
	        'TRL': '₤',
	        'TVD': '$',
	        'UAH': '₴',
	        'GBP': '£',
	        'USD': '$',
	        'UYU': '$U',
	        'UZS': 'лв',
	        'VEF': 'Bs',
	        'VND': '₫',
	        'YER': '﷼',
	        'ZWD': 'Z$' };



	    var tagContent = '(?:[^"\'>]|"[^"]*"|\'[^\']*\')*';
	    var unsafeTagsRegexp = new RegExp(
	    '<(?:' +
	    '!--(?:(?:-*[^->])*--+|-?)' +
	    '|script\\b' + tagContent + '>[\\s\\S]*?</script\\s*' +
	    '|style\\b' + tagContent + '>[\\s\\S]*?</style\\s*' +
	    '|/?[a-z]' +
	    tagContent +
	    ')>',
	    'gi');

	    /**
	            * NOTE: Doesn't work with angular Dependecy Injection
	            * @memberof core.i18n
	            * @ngConstant
	            */
	    exports.lpCoreI18nUtils = {
	        WIDGET_TRANSLATION_PREFERENCE: 'i18nEndPoint',
	        /**
	                                                        * Hash containing currency symbols for every currency code
	                                                        * @example:
	                                                        * ```
	                                                        * lpCoreI18nUtils.CURRENCY_MAP.USD // "$"
	                                                        * ```
	                                                        */
	        CURRENCY_MAP: CURRENCY_MAP,
	        DEFAULT_TRANSLATIONS_PATH: '/locale/',

	        /**
	                                                * Name of the event triggered when locale data is loaded
	                                                */
	        COMMON_I18N_LOAD_EVENT: 'lpi18n:data:load',

	        /**
	                                                     * Name of the event triggered when locale string changes
	                                                     *
	                                                     * @example
	                                                     * ```
	                                                     * lpCoreBus.subscribe(lpCoreI18nUtils.LOCALE_CHANGE_EVENT, function(locale) {
	                                                     *   alert(locale); // alerts current locale
	                                                     * });
	                                                     * lpCoreBus.publish(lpCoreI18nUtils.LOCALE_CHANGE_EVENT, 'nl-NL'); // changes the language of all launchpad widgets
	                                                     * ```
	                                                     */
	        LOCALE_CHANGE_EVENT: 'lpi18n:locale:change',
	        ALL_LOCALES_FILE: 'all.json',

	        /**
	                                       * Normalizes locale string, returning object containing normalized string and external flag.
	                                       * @memberof core.i18n.lpCoreI18nUtils
	                                       * @param   {String} locale to normalize, e.g. 'en-us' or 'en_US' or 'EN-US' becomes 'en-US'
	                                       * @returns {Object} locale object with the external flag
	                                       */
	        parseLocale: function parseLocale(locale) {
	            // hardcode for 'en' -> 'en-US'
	            if (locale === 'en') {return 'en-US';}

	            if (typeof locale === 'string') {
	                var parts = locale.split(/[-_]/);
	                if (!parts[1]) {
	                    parts.push(parts[0]); // nl -> nl-NL, ru -> ru-RU etc.
	                }
	                parts[0] = parts[0].toLowerCase();
	                parts[1] = parts[1].toUpperCase();

	                return parts.join('-');
	            }
	            return '';
	        },

	        sanitize: function sanitize(html) {
	            var initialHtml;
	            do {
	                initialHtml = html;
	                html = html.replace(unsafeTagsRegexp, '');
	            } while (html !== initialHtml);
	            return html.replace(/</g, '&lt;');
	        } };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // @ngInject
	    exports.lpCoreI18nLoader = function (lpCoreUtils, lpCoreI18nUtils, $q, $http, lpI18nCommonTranslation, lpCoreCachePromise, lpCoreBus, lpCoreError) {
	        /**
	                                                                                                                                                         * Returns either cached promise or new one.
	                                                                                                                                                         * @param {String} url - Url of the translation file.
	                                                                                                                                                         * @returns {Object} Promise object
	                                                                                                                                                         */
	        function getPromise(url) {
	            return lpCoreCachePromise({
	                key: url,
	                promise: function promise() {
	                    return $http.get(url);
	                } });

	        }
	        /**
	           * Main i18n loader
	           * @param {Object} options - Loader options
	           * @param {String} options.key - Locale string, added by angular-translate automatically
	           * @param {String} options.widgetUrl - Url of the widget
	           * @param {String} options.i18nPath - Path where translation files are stored
	           * @param {Boolean} options.merged - If false, load (key).json, otherwise load ALL_LOCALES_FILE
	           * @returns {Object} Promise object
	           */
	        return function (options) {

	            var wUrl;

	            // If custom locale file path is specified with preference.
	            // LP11 supports i18nEndPoint (a little unfortunate name), LP12+ let's use localeFilePath (also preference name).
	            if (!options.localeFilePath) {
	                wUrl = options.widgetUrl + lpCoreI18nUtils.DEFAULT_TRANSLATIONS_PATH; // => {widgetBasePath}/locale/
	                wUrl = lpCoreUtils.trimRight(wUrl, '/') + '/' + (options.merged ? lpCoreI18nUtils.ALL_LOCALES_FILE : options.key + '.json');
	            }
	            // Custom localeFilePath is set and ends with forward-slash
	            else if (options.localeFilePath.slice(-1) === '/') {
	                    wUrl = options.localeFilePath + (options.merged ? lpCoreI18nUtils.ALL_LOCALES_FILE : options.key + '.json');
	                } else
	                {
	                    wUrl = options.localeFilePath;
	                }

	            // common translations path
	            var cUrl = options.i18nPath + '/' + (options.merged ? 'common.json' : options.key + '.json');

	            return $q.all({
	                common: getPromise(cUrl),
	                widget: getPromise(wUrl) }).
	            then(function (res) {
	                var data;
	                if (options.merged) {
	                    // if all translations are in the same file, set them only once
	                    if (!lpI18nCommonTranslation) {
	                        lpI18nCommonTranslation = res.common.data; // TODO: doesn't work with [key], check for bug in deck container
	                        lpCoreBus.publish(lpCoreI18nUtils.COMMON_I18N_LOAD_EVENT, lpI18nCommonTranslation);
	                    }
	                    data = lpCoreUtils.extend({}, res.common.data[options.key], res.widget.data[options.key]);
	                } else {
	                    lpI18nCommonTranslation = res.common.data;
	                    lpCoreBus.publish(lpCoreI18nUtils.COMMON_I18N_LOAD_EVENT, lpI18nCommonTranslation);

	                    data = lpCoreUtils.extend({}, res.common.data, res.widget.data);
	                }

	                return data;
	            }).catch(function (err) {
	                lpCoreError.captureException(err);
	            });
	        };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // when triggering LOCALE_CHANGE event in the run phase, do it only once
	    var once = true;
	    var options;

	    function getHtmlAttr(name) {
	        return document.getElementsByTagName('html')[0].getAttribute(name);
	    }

	    /**
	       * @memberof core.i18n
	       * @ngProvider
	       * @ngInject
	       */
	    exports.lpCoreI18n = function (lpCoreUtils, $translateProvider, lpCoreI18nUtils, tmhDynamicLocaleProvider) {

	        // runs only once
	        if (!options) {
	            var lp = window.launchpad;

	            options = {
	                locale: lpCoreI18nUtils.parseLocale(
	                getHtmlAttr('lang') || getHtmlAttr('xml:lang') ||
	                navigator.language || navigator.browserLanguage || navigator.systemLanguage || navigator.userLanguage),

	                merged: true,
	                i18nPath: lpCoreUtils.resolvePortalPlaceholders(
	                lp ? '$(contextRoot)/static/launchpad/modules/config/i18n' : '/bower_components/config/i18n') };



	            if (lp && lp.i18n) {
	                options.merged = lp.i18n.mergedFiles;
	                options.i18nPath = lpCoreUtils.resolvePortalPlaceholders(lp.i18n.path);
	            }
	        }

	        tmhDynamicLocaleProvider.localeLocationPattern(options.i18nPath + '/ng-locale/angular-locale_{{locale}}.js');
	        $translateProvider.preferredLanguage(options.locale);

	        /**
	                                                               * Set up i18n configuration based on widget instance
	                                                               * @param {Object} widget instance widget
	                                                               */
	        this.useWidgetInstance = function (widgetInstance) {
	            $translateProvider.useSanitizeValueStrategy('sanitize');

	            if (lpCoreUtils.isEmpty(widgetInstance.getPreference('locale'))) {
	                return;
	            }

	            // In LP11 this preference path was called "i18nEndPoint" - I think this is not very good name.
	            var localeFilePath = lpCoreUtils.resolvePortalPlaceholders(widgetInstance.getPreference('localeFilePath'));

	            $translateProvider.useLoader('lpCoreI18nLoader', {
	                i18nPath: options.i18nPath,
	                merged: options.merged,
	                widgetUrl: lpCoreUtils.getWidgetBaseUrl(widgetInstance),
	                localeFilePath: localeFilePath });

	        };

	        /**
	            * Service i18n
	            * @param   {Function} $filter           Filter in module ng
	            * @param   {Object}   lpCoreI18nLoader  Request static loader provider
	            * @param   {Object}   $translate        ng-translate 3rd party
	            * @param   {Object}   tmhDynamicLocale  Dynamic locale switcher 3rd party
	            * @private
	            * @returns {Object}                     i18n Service
	            * @ngInject
	            */
	        this.$get = function ($filter, lpCoreI18nLoader, $translate, tmhDynamicLocale, lpCoreBus) {
	            // Syncing the default locale with Containers
	            // This event should be fired only once, not per each widget
	            // setLocale methods of the widget are subsribed to this event
	            if (once) {
	                setTimeout(function () {
	                    lpCoreBus.publish(lpCoreI18nUtils.LOCALE_CHANGE_EVENT, options.locale);
	                }, 0);
	                once = false;
	            }
	            return {
	                /**
	                      * Changes locale of the widget module.
	                      * @memberof core.i18n.lpCoreI18n
	                      * @param {String} locale Locale string, e.g. 'en-US'
	                      */
	                setLocale: function setLocale(locale) {
	                    $translate.use(locale);
	                    tmhDynamicLocale.set(locale.toLowerCase());
	                },

	                /**
	                    * Returns proper currency format, using currency filter.
	                    *
	                    * @example
	                    * ```
	                    * lpCoreI18n.formatCurrency(24, 'USD'); // "$24"
	                    * ```
	                    *
	                    * @memberof core.i18n.lpCoreI18n
	                    * @param   {Number} amount    Amount
	                    * @param   {String} currency  Currency code
	                    * @returns {String} Formatted string
	                    */
	                formatCurrency: function formatCurrency(amount, currency) {
	                    var symbol = $filter('currencySymbol')(currency);
	                    return $filter('currency')(amount, symbol); // built in ng filter, uses page locale.
	                },

	                /**
	                    * Returns localized date format, using date filter
	                    *
	                    * @example
	                    * ```
	                    * lpCoreI18n.formatDate(1288323623006, 'yyyy-MM-dd HH:mm:ss Z'); // "2010-10-29 05:40:23 +0200"
	                    * ```
	                    *
	                    * @memberof core.i18n.lpCoreI18n
	                    * @param   {Number} value   Date as Unix timestamp
	                    * @param   {String} format  Format
	                    * @returns {String}
	                    */
	                formatDate: function formatDate(value, format) {
	                    return $filter('date')(value, format || 'medium');
	                },

	                /**
	                    * Returns a translation instantly from the internal state of loaded translation.
	                    *
	                    * @example
	                    * ```
	                    * lpCoreI18n.instant('Enrol for Estatements'); // "Schrijf je in voor eStatements" for locale "nl-NL"
	                    * ```
	                    *
	                    * @memberof core.i18n.lpCoreI18n
	                    * @param   {String} string  A string which represents a translation id or array of strings.
	                    * @param   {Object} interpolateParams  Object with params.
	                    * @param   {String} interpolationId  The id of the interpolation to use.
	                    * @param   {String} forceLanguage  A language to be used instead of the current language
	                    * @returns {String}
	                    */
	                instant: function instant(string, interpolateParams, interpolationId, forceLanguage) {
	                    return $translate.instant(string, interpolateParams, interpolationId, forceLanguage);
	                } };



	        };
	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    /**
	                   * Renders proper currency symbol.
	                   *
	                   * @example
	                   * ```
	                   * <span>{{'JPY'|currencySymbol}}</span>
	                   * <span>¥</span>
	                   * ```
	                   *
	                   * @memberof core.i18n
	                   * @ngFilter
	                   * @ngInject
	                   */
	    exports.currencySymbol = function (lpCoreI18nUtils) {
	        return function (currency) {
	            return lpCoreI18nUtils.CURRENCY_MAP[currency] || '';
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';


	    var utils = __webpack_require__(36).lpCoreI18nUtils;

	    /**
	                                                     * Use lp-i18n angular directive to translate string used in Launchpad Widget HTML template.
	                                                     *
	                                                     * @example
	                                                     * ```
	                                                     * <span lp-i18n="Statement as of"></span>
	                                                     * ```
	                                                     *
	                                                     * @example
	                                                     * `label`, `placeholder` and `help` attributes inside of `lp-field`, `lp-input`, `lp-text-input`,
	                                                     * `lp-password-input` or `lp-checkbox` directives will also be automatically translated:
	                                                     *
	                                                     * ```
	                                                     * <div lp-field="lp-field" label="Enrol for Estatements"></div>
	                                                     * ```
	                                                     *
	                                                     * @memberof core.i18n
	                                                     * @ngDirective
	                                                     * @ngInject
	                                                     */
	    exports.lpI18n = function ($compile) {
	        function link(scope, el, attr) {
	            attr.$observe('lpI18n', function (val) {
	                //to prevent XSS
	                el.attr('translate', utils.sanitize(val));
	                //need to prevent cycle loop on observable
	                el.removeAttr('lp-i18n');
	                $compile(el)(scope);
	            });
	        }

	        return {
	            restrict: 'AE',
	            link: link,
	            // These 2 options prevent additional other directives recompilations
	            // i.e. ngClick would twice, ngRepeat would render infinite loop, etc.
	            // Need to set priority higher then any other directive.
	            priority: Number.MAX_VALUE,
	            terminal: true };

	    };

	    /**
	        * @memberof core.i18n
	        * @ngDirective
	        * @ngInject
	        */
	    exports.lpI18nSwitch = function (lpCoreBus, lpCoreI18nUtils) {
	        function link(scope, el, attr) {
	            var locales = attr.lpI18nSwitch;
	            if (!locales) {return;}
	            locales = locales.split(',');
	            var id;

	            lpCoreBus.subscribe(lpCoreI18nUtils.LOCALE_CHANGE_EVENT, function (locale) {
	                id = locales.indexOf(locale);
	            });

	            el.on('click', function (e) {
	                e.preventDefault();
	                id = ++id % locales.length;
	                lpCoreBus.publish(lpCoreI18nUtils.LOCALE_CHANGE_EVENT, locales[id]);
	            });
	        }

	        return {
	            template: '<span translate="_languageCode"></span>',
	            restrict: 'AE',
	            link: link };

	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

		'use strict';

		var $ = __webpack_require__(20);

		// @ngInject
		exports.i18nUtils = function ($http, $q, lpCoreUtils) {

			var i18nUtils = {};

			var httpService = {
				getInstance: function getInstance(options) {
					var req = {
						url: lpCoreUtils.resolvePortalPlaceholders(endpoint),
						method: 'GET',
						cache: true,
						data: {},
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/x-www-form-urlencoded;' } };



					return {
						read: function read() {
							return $http(req);
						} };

				},
				resolvePromise: function resolvePromise(data) {
					// Returns an already resolved promise with the `data` value
					var promise = $q.when(data);
					return {
						success: function success(fp) {
							promise.then(fp);
							return promise;
						},
						error: function error(fp) {
							promise.then(null, fp);
							return promise;
						},
						always: function always(fp) {
							promise['finally'](fp);
							return promise;
						} };

				} };


			i18nUtils.loadMessages = function (lpWidget, locale, messageSrcPref) {

				var response;
				messageSrcPref = messageSrcPref || "messageSrc";
				var messageSrc = lpWidget.getPreference(messageSrcPref);
				if (messageSrc) {
					var messagesService = httpService.getInstance({
						endpoint: messageSrc });

					response = messagesService.read();
				} else {
					response = httpService.resolvePromise({});
				}
				return response;
			};

			return i18nUtils;
		};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

		'use strict';

		// @ngInject
		exports.lpMessage = function () {
			return {
				replace: false,
				restrict: "A",
				scope: {
					"key": "=lpMessage",
					"messages": "=lpBundle" },

				template: "{{value}}",
				link: function link(scope, element, attrs) {

					var insertMessage = function insertMessage(key, messages) {

						var value;
						if (messages && messages.hasOwnProperty(key)) {
							value = messages[key];
						} else {
							value = "[" + key + "]";
						}
						scope.value = value;
					};

					scope.$watch("key", function (key) {
						insertMessage(key, scope.messages);
					});
					scope.$watch("messages", function (messages) {
						insertMessage(scope.key, messages);
					});
				} };

		};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               * NOT IMPLEMENTED
	               * @name store
	               * @memberof core
	               * @ngModule
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	  'use strict';

	  module.name = 'core.store';
	  var base = __webpack_require__(3);
	  var deps = [];

	  // https://developer.mozilla.org/en-US/docs/Web/API/Storage
	  function storeProvider() {
	    this.$get = function () {
	      var API = {};

	      /**
	                     * When passed a key name, will return the value stored in that key.
	                     * @param   {String} key  Name of the key you want to retrieve.
	                     * @returns {*} Value stored in the key, if it is not present it will return null.
	                     */
	      API.getItem = function (key) {};

	      /**
	                                        * When passed a key name and value, will add that key to the storage, or update
	                                        * that key's value if it already exists.
	                                        *
	                                        * @param {String} key Name of the key you want to create/update.
	                                        * @param {*} value Value you want to give the key you are creating/updating.
	                                        */
	      API.setItem = function (key, value) {};

	      /**
	                                               * When passed a key name, will remove the value stored in the key
	                                               * and the key itself
	                                               *
	                                               * @param  {String} key Name of the key woy want to remove.
	                                               */
	      API.removeItem = function (key) {};

	      /**
	                                           * Will empty all keys out of the storage.
	                                           */
	      API.reset = function () {};

	      return API;
	    };
	  }

	  module.exports = base.createModule(module.name, deps).
	  provider('lpCoreStore', storeProvider);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               * Launchpad Template Module
	               *
	               * @copyright Backbase B.V.
	               * @author Backbase R&D - Amsterdam - New York
	               *
	               * @name template
	               * @memberof core
	               * @ngModule
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    module.name = 'core.template';

	    var base = __webpack_require__(3);

	    // external module deps
	    var deps = [];

	    // providers holder
	    var providers = {};

	    // directives holder
	    var directives = {};

	    // =============================
	    // Providers
	    // =============================

	    /**
	     * Helper service used by lpTemplate directive.
	     *
	     * @alias lpCoreTemplate
	     * @memberof core.template
	     * @ngProvider
	     * @ngInject
	     */
	    providers.lpCoreTemplate = function (lpCoreUtils) {

	        var defaults = {};

	        var API = {};

	        /**
	                       * Set provider options.
	                       * @param {Object} options Default options for lpCoreTemplate service.
	                       * @returns {Object} this templateProvider instance.
	                       */
	        this.useWidgetInstance = function (widgetInstance) {
	            // Create a map templateLKey -> path
	            var templates = {};
	            var path = lpCoreUtils.getWidgetBaseUrl(widgetInstance);

	            if (widgetInstance.model && widgetInstance.model.preferences && widgetInstance.model.preferences.array) {
	                templates = lpCoreUtils.reduce(widgetInstance.model.preferences.array, function (prev, curr) {
	                    if (curr.name.indexOf('widgetTemplate_') > -1) {
	                        prev[curr.name.replace('widgetTemplate_', '')] = curr.value;
	                    }
	                    return prev;
	                }, {});
	            }

	            if (path) {
	                path = lpCoreUtils.trimRight(path, '/');
	            }

	            lpCoreUtils.extend(defaults, {
	                path: path,
	                templates: templates });

	        };

	        // Provider Template instance
	        // @ngInject
	        this.$get = function (lpCoreConfiguration) {
	            /**
	                                                     * Provider API
	                                                     * @memberof core.template.lpCoreTemplate
	                                                     * @class
	                                                     */
	            API = function API(options) {
	                this.options = options;

	                // Initialise defaults.
	                lpCoreUtils.defaults(
	                this.options,
	                {
	                    // Default template path is the ABS path from config.
	                    path: lpCoreConfiguration.getAbsPath() });


	            };

	            /**
	                * get provider configuration
	                * @returns {Object} configuration option
	                */
	            API.prototype.getOptions = function () {
	                return this.options;
	            };

	            /**
	                * Get absolute template path.
	                * @returns {String}
	                */
	            API.prototype.getOptionsPath = function () {
	                return this.options.path;
	            };

	            /**
	                * Resolve template ID
	                *
	                * @param   {String}  id
	                * @returns {String}
	                */
	            API.prototype.getFullPath = function (id) {
	                var path = this.getOptionsPath();
	                if (path === '/') {
	                    return path + id;
	                } else
	                {
	                    return [path, id].join('/');
	                }
	            };

	            /**
	                * Resolve directive paths
	                * @param {String} src
	                * @param {String} name
	                * @return {String} resolvedPath
	                */
	            API.prototype.resolvePath = function (src, name) {
	                var resolvedPath,
	                templateKey,
	                customTemplate;

	                // If attribute "name" is provided take it as template key otherwise try to extract it from template path
	                if (name) {
	                    templateKey = name;
	                } else
	                {
	                    var match = src.match(/(?:^|\/)([^\/]+?)\.html$/);
	                    templateKey = match && match[1];
	                }

	                if (templateKey && this.options.templates[templateKey]) {

	                    customTemplate = this.options.templates[templateKey];

	                    if (/^https?:\/\//.test(customTemplate)) {
	                        resolvedPath = customTemplate;
	                    } else
	                    {
	                        resolvedPath = this.getFullPath(customTemplate);
	                    }
	                } else
	                {
	                    resolvedPath = this.getFullPath(src);
	                }

	                return resolvedPath;
	            };

	            return new API(defaults);
	        };
	    };

	    // =============================
	    // Directives
	    // =============================

	    /**
	     * Wrapper around [ngInclude][1] directive. Fetches, compiles and includes an external HTML fragment.
	     *
	     * ##### Attributes
	     *
	     * ###### src
	     *
	     * lpTemplate uses `src` attribute as template path. The value of the attribute should be valid Angular expression. For static paths string literal should be used.
	     *
	     * If `src` is not provided `lp-template` attribute is used.
	     *
	     * Below two examples using string literals are equivalent:
	     *
	     * ```
	     * <lp-template src="'templates/accounts.html'"></lp-template>
	     * <div lp-template="'template/accounts.html'"></div>
	     * ```
	     *
	     * Template path could be configured in controller, in this case quotes are not needed:
	     *
	     * ```
	     * <lp-template src="templates.iban"></lp-template>
	     * ```
	     *
	     * ###### name
	     *
	     * `lpTemplate` can also accept optional argument `name`. If provided, it is used for identifing template for customization with template path property. See next section for details.
	     *
	     * If `name` attribute is missing (in most cases) then template key is extracted from resolved template path as substring between last `/` and before `.html` strings. For example, if template path (result of evaluation of the expression for src) is `templates/accounts-header.html` then corresponding template key is `accounts-header`.
	     *
	     * ##### Template keys
	     *
	     * `lpTemplate` directive uses unique identifiers in order to provide a way to overwrite template path with custom preference. Special proprty name must conform the following format:
	     *
	     * ```
	     * widgetTemplate_{template key}
	     * ```
	     *
	     * Every widget that uses `lpTemplate` and allows template cutomization should describe template keys it provides.
	     *
	     * In above example with accounts-header key corresponding property would be `widgetTemplate_accounts-header`.
	     *
	     * [1]: https://docs.angularjs.org/api/ng/directive/ngInclude
	     *
	     * @alias lpTemplate
	     * @memberof core.template
	     * @ngDirective
	     * @ngInject
	     */
	    directives.lpTemplate = function ($compile, lpCoreTemplate, lpCoreUtils) {

	        /**
	                                                                               * @memberof core.template.lpTemplate
	                                                                               * @param {Object} scope
	                                                                               * @param {Object} attrs
	                                                                               * @returns {String} Angular html template
	                                                                               */
	        function getTemplate(scope, attrs, callback) {

	            var srcExp = decodeURIComponent(attrs.lpTemplate || attrs.src),
	            resolvedPath;

	            scope.$watch(srcExp, function (src) {

	                if (!src) {

	                    // For backward compatibility
	                    // If it's "undefined" but looks like template path with html extension then skip it in this digest
	                    if (src === undefined && !/\.html$/.test(srcExp)) {
	                        return callback();
	                    }

	                    // This is likely deprecated old syntax just use this path as is
	                    lpCoreUtils.deprecate('Template expression "' + srcExp + '" is invalid and evaluated to "' + src + '". Raw path is used as is. See LPES-4017 for details.');
	                    src = srcExp;
	                }

	                resolvedPath = lpCoreTemplate.resolvePath(src, attrs.name);

	                callback('<div class="ng-transclude-node"></div><div ng-include src="\'' + resolvedPath + '\'"></div>');

	            });
	        }

	        // Directive configuration
	        return {
	            restrict: 'AE',
	            transclude: true,
	            // Priority should be less then the one of ngIf directive (600) so the can be used on the same element
	            priority: 599,
	            link: function link(scope, element, attrs, controller, $transclude) {

	                getTemplate(scope, attrs, function (template) {

	                    if (template) {
	                        element.html(template).show();

	                        // manually transclude content
	                        $transclude(function (clone) {
	                            element.find('.ng-transclude-node').html(clone);
	                        });

	                        $compile(element.contents())(scope);
	                    }
	                });
	            } };

	    };

	    /**
	        * Alternative to `<script type="text/ng-template">`. Injects the elements content into
	        * [$templateCache][1]. This can be used to allow server-rendered content (i.e. `<g:include>`
	        * content) to be used in angular templates via `ng-include` and similar. This is provided
	        * because `<g:include>` will not render inside `<script>` tags.
	        *
	        * ##### Attributes
	        *
	        * ###### src
	        *
	        * lpTemplateCache uses `src` attribute as the template path (which is also the $templateCache
	        * key). The value of the attribute should be a static string.
	        *
	        * Below two examples using string literals are equivalent:
	        *
	        * ```
	        * <lp-template-cache src="templates/accounts.html"></lp-template>
	        * <div lp-template-cache="template/accounts.html"></div>
	        * ```
	        *
	        * ##### Note
	        *
	        * The content may be briefly visible before this directive has been loaded. It is advisable to use the
	        * `ng-cloak` directive on the same (or a parent) element, or include the following styles in your project.
	        *
	        * ```
	        * lp-template-cache, [lp-template-cache] {
	        *     display: none;
	        * }
	        * ```
	        *
	        * ##### Caution
	        *
	        * The contents of this element will probably be loaded by the browser, even if they are not
	        * `ng-include`d into the page. So, images may be unnecessarily downloaded. This can be avoided
	        * by using a the directive with a `<noscript>` tag.
	        *
	        * [1]: https://docs.angularjs.org/api/ng/service/$templateCache
	        *
	        * @alias lpTemplateCache
	        * @memberof core.template
	        * @ngDirective
	        * @ngInject
	        */
	    directives.lpTemplateCache = function ($templateCache) {
	        var linkFn = function linkFn(scope, element, attrs) {
	            element.css({ display: 'none' });
	            var content = element[0].tagName.toUpperCase() === 'NOSCRIPT' ? 'text' : 'html';
	            $templateCache.put(attrs.lpTemplateCache || attrs.id, element[content]());
	        };

	        return {
	            restrict: 'AE',
	            link: linkFn };

	    };

	    module.exports = base.createModule(module.name, deps).
	    provider(providers).
	    directive(directives);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               * Configures
	               * <a href="https://docs.google.com/document/d/1BtDNCvYegmyzel4YPBFNxJaUZ2ywYUeBbzkLB4LpQzM/edit">updating</a>
	               * widgets' models depending on other widgets actions.
	               *
	               * @copyright Backbase B.V.
	               * @author Backbase R&D - Amsterdam - New York
	               *
	               * @name update
	               * @memberof core
	               * @ngModule
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'core.update';

	    var base = __webpack_require__(3);
	    // core modules
	    var utils = __webpack_require__(21);

	    var deps = [
	    utils.name];


	    module.exports = base.createModule(module.name, deps).
	    provider(__webpack_require__(46));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /*global define*/
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // load config list of relations
	    var config = __webpack_require__(47);
	    var utils = __webpack_require__(3).utils;

	    // main container for subscribers
	    var listeners = {};

	    /**
	                         *
	                         * @memberof core.update
	                         * @ngProvider
	                         * @ngInject
	                         */
	    exports.lpCoreUpdate = function () {

	        // @ngInject
	        this.$get = function () {

	            /**
	                                  * Very rough check for the same callbacks already added to the queue
	                                  *
	                                  * @param list
	                                  * @param obj
	                                  * @returns {Boolean}
	                                  * @private
	                                  */
	            var checkSameObjectEnlisted = function checkSameObjectEnlisted(list, obj) {
	                var res = false;

	                if (!utils.isArray(list)) {return res;}

	                list.forEach(function (o) {
	                    if (o === obj) {res = true;}
	                });

	                return res;
	            };

	            /**
	                * Get the list of all queues we should apply for a particular name
	                *
	                * @param name
	                * @returns {*}
	                * @private
	                */
	            var getList = function getList(name) {
	                var list,aux,main = 'actions',deps = 'deps';

	                if (!name || !config.hasOwnProperty(main) || !config.hasOwnProperty(deps)) {return false;}

	                list = config[main][name] || [];
	                aux = config[deps][name] || [];

	                return utils.chain(list).union(aux).uniq().value();
	            };

	            /**
	                * Invoke all callbacks for a single queue
	                *
	                * @param name
	                * @private
	                */
	            var invokeSingleQueue = function invokeSingleQueue(name) {

	                var queue = listeners[name];
	                if (!queue || !utils.isArray(queue) || queue.length < 1) {return;}

	                queue.forEach(function (callback) {
	                    try {
	                        callback();
	                    } catch (error) {
	                        // TODO: lpCoreError.captureException(error);
	                        throw new Error(error);
	                    }
	                });
	            };

	            /**
	                * Go through the list of queues and initiate invoking
	                *
	                * @param list
	                * @private
	                */
	            var invokeQueues = function invokeQueues(list) {
	                if (!list || !utils.isArray(list) || list.length < 1) {return;}

	                list.forEach(function (name) {
	                    invokeSingleQueue(name);
	                });
	            };

	            /**
	                * Add listener to proper widget's queue
	                *
	                * @example
	                * Subscribing at an update event within the widget's controller:
	                *
	                * ```
	                * var invoker = function() {
	                *   ctrl.widgetModel.load();
	                * };
	                *
	                * lpCoreUpdate.subscribe(widget.name, invoker);
	                * ```
	                *
	                * @memberof core.update.lpCoreUpdate
	                * @param   {String}    name
	                * @param   {Function}  callback
	                * @returns {Undefined}
	                */
	            var subscribe = function subscribe(name, callback) {
	                if (!name || typeof callback !== 'function') {return;}

	                // create new queue (if needed)
	                if (!listeners.hasOwnProperty(name)) {listeners[name] = [];}

	                if (!checkSameObjectEnlisted(listeners[name], callback)) {
	                    listeners[name].push(callback);
	                }
	            };

	            /**
	                * Invoke callbacks for this particular event name
	                *
	                * @example
	                * Triggering update event:
	                *
	                * ```
	                * var eventName = widget.name;
	                * lpCoreUpdate.trigger(eventName);
	                * ```
	                *
	                * @memberof core.update.lpCoreUpdate
	                * @param   {String}    name
	                * @returns {Undefined}
	                */
	            var trigger = function trigger(name) {
	                if (name) {invokeQueues(getList(name));}
	            };

	            return {
	                subscribe: subscribe, /* (name, callback) */
	                trigger: trigger /* (sourceEventName) */ };


	        };
	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.exports = {
	        'actions': {
	            'newPaymentOrderInitiated': ['reviewTransfer'] },


	        'deps': {
	            'transactions': ['accounts'] } };



	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               * Core widget module provides services lpWidget and value widget into application
	               * @name widget
	               * @memberof core
	               * @ngModule
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	  'use strict';

	  module.name = 'core.widget';
	  var base = __webpack_require__(3);
	  var deps = [];

	  module.exports = base.createModule(module.name, deps).
	  provider(__webpack_require__(49));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    /**
	                      * lpCoreWidget provider
	                      * @return {object} angular provider
	                      * @ngInject
	                      */
	    exports.lpCoreWidget = function widgetProvider($provide, lpCoreUtils, lpCoreBusProvider) {
	        var widget;

	        this.useWidgetInstance = function (widgetInstance) {
	            widget = widgetInstance;

	            /**
	                                      * @method addResolvedPreference get normalized property from widget model
	                                      * @param {String} propName
	                                      * @returns {Object} value
	                                      */
	            widgetInstance.getResolvedPreference = function (propName) {
	                var val = this.getPreference(propName);
	                return lpCoreUtils.resolvePortalPlaceholders(val);
	            };

	            $provide.provider('lpWidget', function () {
	                /**
	                                                        * @returns {Object} widgetInstance
	                                                        */
	                this.getInstance = this.$get = function () {
	                    return widgetInstance;
	                };
	            });

	            $provide.value('widget', widget); // will be deprecated

	            var eventChannel = widgetInstance.getPreference('eventChannel') || widgetInstance.getPreferenceFromParents('eventChannel');
	            lpCoreBusProvider.registerChannel(eventChannel);

	        };

	        this.$get = this.getInstance = function () {
	            return widget;
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(3);

	    var deps = [];


	    module.exports = base.ng.module('common', deps).
	    constant('httpServicesConfig', {
	        defaultConfig: {
	            cacheTimeout: 1000,
	            xhrTimeout: 5000 } }).


	    service(__webpack_require__(51));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';
	    // Feature detect + local reference
	    var hasStorage = function hasStorage() {
	        var uid = new Date();
	        var storage;
	        var result;
	        try {
	            (storage = window.localStorage).setItem(uid, uid);
	            result = storage.getItem(uid) == uid;
	            storage.removeItem(uid);
	            return result && storage;
	        } catch (exception) {}
	    };

	    // @ngInject
	    exports.httpService = function ($http, $q, $timeout, httpServicesConfig, lpCoreUtils) {

	        /**
	                                                                                            * Creates a new Service instance
	                                                                                            * @param config
	                                                                                            * @constructor
	                                                                                            */
	        var HttpService = function HttpService(config) {
	            lpCoreUtils.assign(this, httpServicesConfig.defaultConfig, config);
	        };

	        /**
	            * Read operation for this service,
	            * Will send an asynchronous GET request to this service's endpoint
	            * @param {Object} params Add get parameters
	            * @param {Boolean} force bypass cache
	            * @returns {Object} an xhr promise
	            */
	        HttpService.prototype.read = function (params, force) {

	            var self = this;

	            var cacheId = getCacheKey(this.endpoint, params),
	            promise;

	            if (!force) {
	                promise = getCacheItem(cacheId);
	            }

	            if (!promise) {
	                promise = makeXhrRequest(this.endpoint, 'GET', {}, this.contentType, params).
	                success(function (response) {
	                    setCacheItem(cacheId, response, self.cacheTimeout);
	                });
	            }

	            return promise;
	        };

	        /**
	            *
	            * @returns {String}
	            * @private
	            */
	        var getCacheKey = function getCacheKey(url, params) {
	            params = params ? "." + JSON.stringify(params) : "";
	            return "launchpad.services/" + url + params;
	        };

	        /**
	            *
	            * @returns {null}
	            * @private
	            */
	        var getCacheItem = function getCacheItem(cacheId) {
	            var cacheData = hasStorage() ? sessionStorage.getItem(cacheId) : null;
	            var promise = null;
	            if (cacheData) {
	                try {
	                    cacheData = JSON.parse(cacheData);
	                    if (cacheData.expires && cacheData.expires > new Date().getTime()) {
	                        // Cache hit: Expires in the future, resolve the promise.
	                        promise = resolvePromise(cacheData.data);
	                    } else {
	                        // Cache miss: remove stale item.
	                        clearCacheItem(cacheId);
	                    }
	                } catch (e) {
	                    // Silently ignore errors - will return null.
	                }
	            }

	            return promise;
	        };

	        /**
	            *
	            * @param string cacheId
	            * @param mixed data
	            * @param int timeout
	            * @private
	            */
	        var setCacheItem = function setCacheItem(cacheId, data, timeout) {

	            if (hasStorage()) {
	                try {
	                    sessionStorage.setItem(cacheId, JSON.stringify({
	                        expires: new Date().getTime() + timeout,
	                        data: data }));

	                } catch (error) {}
	            }
	        };

	        /**
	            *
	            * @returns {String}
	            * @private
	            */
	        var clearCacheItem = function clearCacheItem(cacheId) {
	            sessionStorage.removeItem(cacheId);
	        };

	        /**
	            * Create operation for this service
	            * Will send a POST request to this service's endpoint
	            * @param conf
	            * @returns {*}
	            */
	        HttpService.prototype.create = function (config) {
	            config = lpCoreUtils.assign({}, {
	                method: 'POST' },
	            config);
	            var contentType = config.contentType || this.contentType;

	            return makeXhrRequest(this.endpoint, config.method, config.data, contentType);
	        };

	        /**
	            * Update operation for this service
	            * Will send a PUT request to this service's endpoint
	            * @param conf
	            * @returns {*}
	            */
	        HttpService.prototype.update = function (config) {
	            config = lpCoreUtils.assign({}, {
	                method: 'PUT' },
	            config);
	            var contentType = config.contentType || this.contentType;

	            return makeXhrRequest(this.endpoint, config.method, config.data, contentType);
	        };

	        /**
	            * Delete operation for this service
	            * Will send a DELETE request to this service's endpoint
	            * @param conf
	            * @returns {*}
	            */
	        HttpService.prototype.del = function (config) {
	            config = lpCoreUtils.assign({}, {
	                method: 'DELETE' },
	            config);
	            return makeXhrRequest(this.endpoint, config.method, config.data, this.contentType);
	        };

	        /**
	            *
	            * @param conf
	            * @returns {*}
	            * @private
	            */
	        // Known issue with null: https://github.com/angular/angular.js/issues/2191
	        var makeXhrRequest = function makeXhrRequest(url, method, data, contentType, params, timeout) {

	            function isTesting() {
	                return window.location.protocol === "file:" || typeof window.__karma__ !== "undefined";
	            }

	            // Prevent GET caching. (small hack for url regex matching in unit tests)
	            if (method === 'GET' && !isTesting()) {
	                params = lpCoreUtils.assign(params || {}, {
	                    '_': new Date().getTime() });

	            }

	            contentType = contentType || 'application/x-www-form-urlencoded;';
	            if (contentType === 'application/x-www-form-urlencoded;') {
	                data = lpCoreUtils.buildQueryString(data || {});
	            }

	            var config = {
	                method: method,
	                url: url,
	                params: params,
	                data: data,
	                cache: false,
	                headers: {
	                    'Accept': 'application/json',
	                    'Content-Type': contentType },

	                timeout: timeout };


	            var promise = $http(config);
	            return promise;
	        };

	        var resolvePromise = function resolvePromise(data) {
	            var deferred = $q.defer(),
	            promise = deferred.promise;

	            // Defining `success` and `always` method for callbacks.
	            // `error` should never be called since the promise is resolved
	            promise.success = function (fn) {
	                promise.then(function (response) {
	                    fn(response);
	                }, null);
	                return promise;
	            };

	            promise.error = function (fn) {
	                promise.then(null, function (response) {
	                    fn(response);
	                });
	                return promise;
	            };

	            promise.always = function (fn) {
	                promise.then(null, null, function (response) {
	                    fn(response);
	                });
	                return promise;
	            };

	            $timeout(function () {
	                deferred.resolve(data);
	            });

	            return promise;
	        };

	        // Service pool
	        var services = {};





	        /**
	                            * Replaces variables within a url. For example
	                            *
	                            * @example
	                            * ${contextPath}/profile
	                            * is merged with
	                            * {
	                            *    contextPath: "/portalserver"
	                            * }
	                            * and becomes /portalserver/profile
	                            *
	                            * @param url {String} A url possibly contain vars to replace
	                            * @param urlVars {Object} Map of replacement vars
	                            */
	        var replaceUrlVars = function replaceUrlVars(url, urlVars) {
	            if (typeof url === "string" && (typeof urlVars === 'undefined' ? 'undefined' : _typeof(urlVars)) === "object") {
	                for (var urlVar in urlVars) {
	                    if (urlVars.hasOwnProperty(urlVar)) {
	                        var urlVarRegexp = new RegExp("\\$\\(" + urlVar + "\\)", "g");
	                        url = url.replace(urlVarRegexp, urlVars[urlVar]);
	                    }
	                }
	            }

	            return url;
	        };


	        var getServiceInstance = function getServiceInstance(config) {
	            // Validate
	            if (!config.endpoint || typeof config.endpoint !== "string") {
	                throw new Error("You must specify an endpoint in your service config");
	            }

	            if (!services[config.endpoint]) {
	                // Fix paramaterized context path (and backwards compatible with contextRoot)
	                // Update variables in endpoint url [ /transactions/$(transactiondId) ]
	                config.endpoint = lpCoreUtils.resolvePortalPlaceholders(config.endpoint, config.urlVars);
	                config.endpoint = replaceUrlVars(config.endpoint, config.urlVars);
	                services[config.endpoint] = new HttpService(config);
	            }

	            return services[config.endpoint];
	        };

	        return {
	            getInstance: getServiceInstance,
	            resolvePromise: resolvePromise };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               * @deprecated will be removed in LP v0.13.x
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    module.name = 'core-deprecated';

	    var base = __webpack_require__(3);

	    var deps = [];

	    module.exports = base.createModule(module.name, deps).
	    factory(__webpack_require__(53)).
	    service(__webpack_require__(54)).
	    service(__webpack_require__(55)).
	    service(__webpack_require__(56)).
	    service(__webpack_require__(57));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var base = __webpack_require__(3);
	    var utils = base.utils;

	    // @ngInject
	    exports.formDataPersistence = function () {

	        function hasStorage() {
	            var uid = new Date().getTime().toString();
	            var storage;
	            var result;
	            try {
	                (storage = window.localStorage).setItem(uid, uid);
	                result = storage.getItem(uid) === uid;
	                storage.removeItem(uid);
	                return result && storage;
	            } catch (err) {
	                base.log.warn(err);
	            }
	        }

	        /**
	           * Creates a new FormDataPersistenceController instance
	           * @constructor
	           */
	        var FormDataPersistenceController = function FormDataPersistenceController() {
	        };

	        /**
	            * Save the form data in session storage with the form name as the key
	            * @param formName a string value of the form/widget name
	            * @param a JS object representing the values of the form
	            */
	        FormDataPersistenceController.prototype.saveFormData = function (formName, formObject) {
	            if (hasStorage()) {
	                var stringifiedFormObject = JSON.stringify(formObject);
	                window.sessionStorage.setItem(formName, stringifiedFormObject);
	            }
	        };

	        /**
	            * Removes saved data from session storage by form name
	            * @param formName the name of the widget form to remove
	            */
	        FormDataPersistenceController.prototype.removeFormData = function (formName) {
	            if (hasStorage()) {
	                window.sessionStorage.removeItem(formName);
	            }
	        };

	        /**
	            * Return the stored string of the form object
	            * @param widget form name
	            */
	        FormDataPersistenceController.prototype.getFormData = function (formName) {

	            var widgetForm = JSON.parse(window.sessionStorage.getItem(formName));

	            var formatObject = function formatObject(thisObject) {
	                for (var key in thisObject) {
	                    if (thisObject.hasOwnProperty(key)) {
	                        if (key.toLowerCase().indexOf('date') > -1 && typeof thisObject[key] !== 'boolean') {
	                            var testDate = new Date(thisObject[key]);
	                            //TODO: investigate better approach
	                            if (!isNaN(testDate.getTime())) {
	                                //a valid date
	                                thisObject[key] = testDate;
	                            }
	                        }

	                        if (thisObject[key] instanceof Object) {
	                            formatObject(thisObject[key]);
	                        }
	                    }
	                }

	                return thisObject;
	            };

	            formatObject(widgetForm);

	            return widgetForm;
	        };

	        /**
	            * Returns a flag if the form is currently saved
	            * @formName the name of the widget form to check
	            */
	        FormDataPersistenceController.prototype.isFormSaved = function (formName) {
	            var saved = window.sessionStorage.getItem(formName);
	            return saved === null ? false : true;
	        };

	        return {
	            getInstance: function getInstance() {
	                utils.deprecate('formDataPersistence is deprecated. It is now part of new transfer widget.');
	                return new FormDataPersistenceController();
	            } };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var base = __webpack_require__(3);
	    var utils = base.utils;

	    // @ngInject
	    exports.ProfileContactService = function ($http, lpWidget, lpCoreUtils) {

	        utils.deprecate('ProfileContactService is deprecated. Use lpUserDetails in module-users.');

	        var url = lpCoreUtils.resolvePortalPlaceholders(lpWidget.getPreference('saveUrl'));

	        this.read = function () {
	            return $http.get(url);
	        };

	        this.save = function (field, value) {
	            var data = {};
	            data[field] = value;

	            return $http.put(url, $.param(data), {
	                headers: {
	                    'Accept': 'application/json',
	                    'Content-Type': 'application/x-www-form-urlencoded;' } });


	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var base = __webpack_require__(3);
	    var angular = base.ng;
	    var utils = base.utils;
	    // @ngInject
	    exports.ProfileDetailsService = function ($http, lpCoreI18n, lpCoreError) {

	        utils.deprecate('ProfileDetailsService is deprecated. Use lpUserDetails in module-users.');

	        var defaults = {
	            counterPartyServiceUrl: '$(servicesPath)/services/rest/v1/party-data-management/party' };

	        var ProfileDetailService = this;
	        ProfileDetailService.config = defaults;

	        ProfileDetailService.setConfig = function (config) {
	            ProfileDetailService.config = angular.extend(defaults, config);
	        };

	        function doI18n(profileDetails) {
	            var detailsParsed = [];
	            utils.each(profileDetails, function (value, key) {
	                detailsParsed.push({
	                    key: lpCoreI18n.instant(key),
	                    value: key === 'dateOfBirth' ? lpCoreI18n.formatDate(value) : lpCoreI18n.instant(value) });

	            });
	            return detailsParsed;
	        }

	        // Return data in correct key, value format
	        ProfileDetailService.formatResponse = function (response) {
	            var data = {
	                fullname: [response.firstName, response.lastName].join(' '),
	                details: doI18n(response.details),
	                activities: [],
	                photoUrl: response.photoData };


	            if (!data.photoUrl && response.photoUrl) {
	                data.photoUrl = utils.decodePhotoUrl(response.photoUrl);
	            }

	            // Activities
	            if (response.activities) {
	                if (response.activities.lastLoggedIn) {
	                    data.activities.push({ key: 'Last Logged In', value: lpCoreI18n.formatDate(response.activities.lastLoggedIn, 'medium') });
	                }
	            }

	            return data;
	        };

	        ProfileDetailService.getData = function () {
	            var url = utils.resolvePortalPlaceholders(ProfileDetailService.config.counterPartyServiceUrl || defaults.counterPartyServiceUrl);

	            return $http.get(url, null, {
	                headers: {
	                    'Accept': 'application/json',
	                    'Content-Type': 'application/x-www-form-urlencoded;' } });


	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var utils = __webpack_require__(3).utils;

	    // @ngInject
	    exports.PreferenceService = function ($http, $filter, lpCoreUtils, lpWidget) {

	        utils.deprecate('PreferenceService is deprecated. Use lpUsersPreference in module-users.');

	        var preferenceEndpoint = lpWidget.getPreference('preferenceService');
	        var url = lpCoreUtils.resolvePortalPlaceholders(preferenceEndpoint);
	        var headers = {
	            'Accept': 'application/json',
	            'Content-Type': 'application/json',
	            'Cache-Control': 'no-cache, no-store, must-revalidate',
	            'Pragma': 'no-cache',
	            'Expires': '0' };


	        this.read = this.get = function () {
	            return $http.get(url, {
	                headers: headers });

	        };

	        this.save = function (field, value) {
	            var data = {};
	            data[field] = value;

	            return $http.put(url, lpCoreUtils.buildQueryString(data), {
	                headers: headers });

	        };
	        this.put = function (field, value) {
	            var data = {};
	            data[field] = value;

	            return $http.put(url + '/' + field, $filter('json')(data), {
	                headers: headers });

	        };
	    };


	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var utils = __webpack_require__(3).utils;

	    // @ngInject
	    exports.P2PService = function ($http, lpWidget, lpCoreUtils) {

	        utils.deprecate('P2PService is deprecated. Use lpP2P in module-p2p.');

	        var enrollmentEndpoint = lpWidget.getPreference('p2pEnrollmentEndpoint');

	        var editEmailEndpoint = '/emails/';

	        enrollmentEndpoint = lpCoreUtils.resolvePortalPlaceholders(lpWidget.getPreference('p2pEnrollmentEndpoint'));

	        this.emailType = {
	            primary: 'PRIMARY',
	            secondary: 'SECONDARY' };


	        this.emailStatus = {
	            verified: 'VERIFIED',
	            unverified: 'UNVERIFIED' };



	        this.getUserEnrollmentDetails = function () {

	            return $http.get(enrollmentEndpoint, null, {
	                headers: {
	                    'Accept': 'application/json',
	                    'Content-Type': 'application/json;' } });


	        };

	        //enroll user in P2P service based on details passed
	        this.enrollUserForP2P = function (value) {

	            return $http.post(enrollmentEndpoint, value, {
	                headers: {
	                    'Accept': 'application/json',
	                    'Content-Type': 'application/json;' } });


	        };


	        this.editP2PEnrollment = function (data) {


	            return $http.put(enrollmentEndpoint, data, {
	                headers: {
	                    'Accept': 'application/json',
	                    'Content-Type': 'application/json;' } });


	        };

	        //modify registered users P2P details
	        this.editP2PDepositAccount = function (value) {

	            var data = {
	                accountNumber: value };


	            return $http.put(enrollmentEndpoint, data, {
	                headers: {
	                    'Accept': 'application/json',
	                    'Content-Type': 'application/json;' } });


	        };

	        //adds a secondary P2P Email address
	        this.addP2PEmailAddress = function (emailAddress) {
	            var data = {
	                value: emailAddress };


	            return $http.post(enrollmentEndpoint + editEmailEndpoint, data, {
	                headers: {
	                    'Accept': 'application/json',
	                    'Content-type': 'application/json;' } });


	        };

	        //edits a specific email, primary or secondary and email value
	        this.editP2PEmailAddress = function (email) {
	            var data = {
	                value: email.value,
	                type: email.type };


	            return $http.put(enrollmentEndpoint + editEmailEndpoint + email.id, data, {
	                headers: {
	                    'Accept': 'application/json',
	                    'Content-Type': 'application/json;' } });



	        };

	        //edits the address type
	        this.editP2PEmailAddressType = function (email) {
	            var data = {
	                type: email.type };


	            return $http.put(enrollmentEndpoint + editEmailEndpoint + email.id, data, {
	                headers: {
	                    'Accept': 'application/json',
	                    'Content-Type': 'application/json;' } });


	        };

	        //deletes a specified email address
	        this.deleteP2PEmailAddress = function (email) {

	            return $http({ method: 'DELETE', url: enrollmentEndpoint + editEmailEndpoint + email.id });
	        };



	        this.verifyCode = function (email, code) {

	            var data = {
	                verification: {
	                    email: email,
	                    code: code } };



	            return $http.put(enrollmentEndpoint, data, {
	                headers: {
	                    'Accept': 'application/json',
	                    'Content-Type': 'application/json;' } });


	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// scripts/main.js